function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.13,175.56c8.19,39.79,5.48,90.11-22.65,122.15-42.49,48.43-22.3,94.5-118.41,149.35a223.52,223.52,0,0,1-44.23,19.47,185.56,185.56,0,0,1-23,5.61c-68.62,12.17-127.77-18.71-162.16-68.26-45.24-65.16-18.47-126.54.22-164.37S86.71,106.07,180.77,51.4a216,216,0,0,1,45.45-20C262.48,20.31,305.62,19.1,341,34.74q4,1.75,7.86,3.77C399.38,64.71,436,121.31,447.13,175.56Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.13,175.56c8.19,39.79,5.48,90.11-22.65,122.15-42.49,48.43-22.3,94.5-118.41,149.35a223.52,223.52,0,0,1-44.23,19.47,185.56,185.56,0,0,1-23,5.61c-68.62,12.17-127.77-18.71-162.16-68.26-45.24-65.16-18.47-126.54.22-164.37S86.71,106.07,180.77,51.4a216,216,0,0,1,45.45-20C262.48,20.31,305.62,19.1,341,34.74q4,1.75,7.86,3.77C399.38,64.71,436,121.31,447.13,175.56Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.61,407.4c2.23.42,7.16-.83,7.16-.83s-1.81-3-2-3.17c-1.61-2-5.91-5-8.62-4a3.43,3.43,0,0,0-1.72,4.8C67.39,406.06,69.71,407.05,71.61,407.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.86,459.1h1.88l-.21-.46c-.57-1.27-1.2-2.62-1.86-4a38.53,38.53,0,0,0,3.44-2.7c1.81,1.23,5.93,2.21,6.46,2.33-.21,1.36-.44,2.67-.68,3.91,0,.31-.11.62-.17.92h1.76c0-.21.07-.41.11-.62.22-1.38.44-2.85.65-4.37.56,0,5.1-.12,7-1,1.75-.84,3.73-2.39,4.14-4.4a3.43,3.43,0,0,0-2.91-4.19c-2.88-.28-6.27,3.69-7.3,6.07-.06.14-.55,1.73-.84,2.74.08-.62.17-1.22.24-1.86.16-1.26.28-2.53.42-3.89,0-.66.09-1.32.13-2s0-1.37,0-2.07c0-1.61,0-3.24-.15-4.89,1.1.14,5,.57,6.89,0s4-1.79,4.75-3.71a3.43,3.43,0,0,0-2.23-4.59c-2.81-.71-6.76,2.71-8.14,4.89-.08.14-.9,1.82-1.32,2.75-.07-1-.14-2-.24-3-.3-2.88-.68-5.78-1.06-8.68l-.33-2.66c.4.05,5.06.66,7.14,0,1.85-.56,4.05-1.8,4.75-3.72a3.42,3.42,0,0,0-2.24-4.58c-2.8-.72-6.75,2.7-8.13,4.89-.1.16-1.27,2.59-1.54,3.22-.23-2-.45-3.91-.59-5.84a60.37,60.37,0,0,1-.08-7.83c.18,0,5,.69,7.18,0,1.84-.56,4-1.79,4.75-3.71a3.44,3.44,0,0,0-2.24-4.59c-2.81-.72-6.76,2.7-8.14,4.89-.1.17-1.36,2.78-1.55,3.27,0-.15,0-.31,0-.46a44.3,44.3,0,0,1,1.34-7.74c.35-1.4.77-2.72,1.2-4,.89.22,5,1.16,7,.79s4.22-1.34,5.13-3.17a3.44,3.44,0,0,0-1.72-4.81c-2.71-1-7,1.94-8.62,4-.09.11-.86,1.33-1.4,2.22.2-.57.4-1.17.61-1.71.77-2,1.61-3.88,2.36-5.5.43-.91.84-1.73,1.24-2.49,1-.25,5-1.29,6.51-2.51s3.13-3.13,3.09-5.17a3.44,3.44,0,0,0-3.74-3.48c-2.88.35-5.33,5-5.82,7.5,0,.22-.32,3.73-.27,3.71h.06c-.4.72-.81,1.51-1.24,2.37-.79,1.6-1.67,3.42-2.48,5.46a59.51,59.51,0,0,0-2.34,6.71,44.53,44.53,0,0,0-1.52,7.8v.1c-.18-.83-.75-3.14-.81-3.31-.9-2.43-4.06-6.59-7-6.46a3.43,3.43,0,0,0-3.14,4c.3,2,2.19,3.68,3.89,4.61,1.91,1.05,6.62,1.41,7,1.44a60.45,60.45,0,0,0-.09,8.09c.07,1.58.2,3.16.35,4.74-.18-.71-.34-1.35-.37-1.43-.9-2.43-4.06-6.59-7-6.46a3.43,3.43,0,0,0-3.13,4c.3,2,2.19,3.68,3.89,4.62s5.72,1.33,6.79,1.42l.18,1.82c.31,2.91.64,5.81.87,8.67.08,1,.12,2,.17,3-.16-.64-.29-1.17-.32-1.25-.9-2.42-4.06-6.58-7-6.46a3.44,3.44,0,0,0-3.14,4c.3,2,2.19,3.68,3.89,4.61s5.33,1.3,6.6,1.41c0,1,0,2,0,3,0,.68,0,1.33-.09,2s-.12,1.33-.17,2c-.16,1.26-.31,2.57-.5,3.8-.12.85-.25,1.66-.38,2.48-.07-1-.25-3-.28-3.12a13.42,13.42,0,0,0-3.19-5.92A3.73,3.73,0,0,0,116,444a3.42,3.42,0,0,0-4.73-1.9c-2.56,1.35-3.19,6.54-2.74,9.09,0,.15.49,1.75.8,2.75-.27-.56-.53-1.11-.82-1.69-.56-1.14-1.16-2.26-1.79-3.47l-1-1.74c-.32-.58-.73-1.16-1.09-1.75-.88-1.35-1.84-2.68-2.83-4,1-.49,4.51-2.3,5.75-3.8s2.39-3.73,1.91-5.72a3.42,3.42,0,0,0-4.39-2.59c-2.74.95-4.15,6-4.09,8.57,0,.16.25,2,.41,3-.6-.78-1.2-1.57-1.83-2.35-1.84-2.23-3.77-4.44-5.68-6.65-.59-.68-1.16-1.36-1.74-2,.36-.18,4.59-2.24,6-3.91,1.23-1.49,2.38-3.73,1.91-5.72a3.42,3.42,0,0,0-4.39-2.59c-2.74,1-4.15,6-4.09,8.56,0,.2.37,2.86.49,3.53-1.27-1.5-2.53-3-3.71-4.54a60.07,60.07,0,0,1-4.39-6.48c.17-.08,4.59-2.21,6-3.93,1.23-1.49,2.39-3.73,1.91-5.72a3.42,3.42,0,0,0-4.39-2.59c-2.74.95-4.15,6-4.09,8.57,0,.2.4,3.07.51,3.58l-.25-.39a44.42,44.42,0,0,1-3.15-7.19c-.48-1.36-.86-2.69-1.2-4,.86-.31,4.79-1.79,6.24-3.19s2.78-3.44,2.53-5.47a3.42,3.42,0,0,0-4.08-3.06c-2.83.64-4.78,5.49-5,8.06,0,.14,0,1.58.06,2.63-.14-.59-.31-1.2-.43-1.77-.49-2.13-.8-4.12-1.07-5.88-.14-1-.25-1.91-.34-2.76.69-.75,3.42-3.81,4-5.69s.88-4.33-.28-6a3.42,3.42,0,0,0-5-.83c-2.21,1.87-1.71,7.07-.73,9.46.09.21,1.79,3.29,1.83,3.25l0,0c.07.82.16,1.7.28,2.66.22,1.77.49,3.77.94,5.93A60.5,60.5,0,0,0,80,411a44.51,44.51,0,0,0,3,7.35l0,.08c-.61-.6-2.35-2.21-2.5-2.31-2.09-1.53-7-3.26-9.37-1.56a3.44,3.44,0,0,0-.39,5.09c1.37,1.53,3.86,1.86,5.79,1.71,2.17-.18,6.3-2.48,6.63-2.66a59.78,59.78,0,0,0,4.38,6.8c.93,1.27,1.91,2.52,2.91,3.76-.54-.5-1-.94-1.1-1-2.09-1.53-7-3.26-9.36-1.56a3.43,3.43,0,0,0-.39,5.09c1.36,1.53,3.85,1.86,5.78,1.71s5.51-2,6.45-2.56l1.15,1.41c1.87,2.26,3.74,4.5,5.51,6.76.63.79,1.21,1.6,1.8,2.4l-.95-.86c-2.09-1.53-7-3.25-9.37-1.55a3.43,3.43,0,0,0-.39,5.09c1.36,1.52,3.86,1.86,5.78,1.7s5.17-1.86,6.28-2.47c.58.84,1.16,1.69,1.68,2.53.35.58.72,1.12,1,1.72l1,1.76c.56,1.14,1.15,2.31,1.68,3.44.37.78.71,1.53,1,2.28-.61-.79-1.84-2.33-2-2.45-1.83-1.83-6.44-4.28-9-3a3.42,3.42,0,0,0-1.15,5c1.11,1.71,3.53,2.42,5.45,2.56,2.13.15,6.39-1.41,6.92-1.61C108.9,456.86,109.4,458,109.86,459.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,397c.05,0,.14-3.5.12-3.72-.23-2.58-2.18-7.43-5-8.07a3.42,3.42,0,0,0-4.08,3.06c-.26,2,1.14,4.13,2.52,5.47C117.18,395.3,122,397,122,397Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232,350.73s-37.83,7.19-42,12.92-14.58,36.19-15.46,37.51-18.72,28-21.36,35.67-.66,14.54,6,18.72,13.43,2.2,16.73,2.2,11.89-7.26,12.55-10.35S191.08,436,191.08,436l12.33-21.58,7.48,44.92H313.73l7-42.94L342.35,456H378l-22.24-47.34-12.33-22.24s-4.85-16.52-12.34-23.34-17.83-9-21.35-9.25-13-2.42-17.84-3.53-15-4.4-15-4.4Z",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.73,459.79H210.89a.5.5,0,0,1-.49-.42l-7.25-43.53-11.6,20.3c-.2.81-2,8.48-2.63,11.37-.73,3.41-9.63,10.74-13,10.74-.66,0-1.49.09-2.44.19-3.66.37-9.19.94-14.56-2.47-6.67-4.22-8.91-11.26-6.15-19.3,2.48-7.25,18.22-31,21.34-35.68l.08-.11c.23-.36,1.48-3.73,2.93-7.64,3.58-9.67,9.58-25.84,12.53-29.89,4.25-5.82,40.78-12.81,42.33-13.11h0l44.92-4.85a.5.5,0,0,1,.21,0c.1,0,10.16,3.31,14.93,4.4l1,.23c5,1.15,13.47,3.08,16.72,3.28s13.91,2.31,21.66,9.38c7.37,6.71,12.1,22.29,12.46,23.51l12.3,22.2,22.26,47.37a.51.51,0,0,1,0,.48.5.5,0,0,1-.42.23H342.35a.48.48,0,0,1-.43-.26L321,417.87l-6.81,41.5A.5.5,0,0,1,313.73,459.79Zm-102.41-1h102l7-42.52a.51.51,0,0,1,.41-.41.5.5,0,0,1,.52.26l21.44,39.37h34.59l-21.9-46.63L343,386.65a.42.42,0,0,1,0-.1c-.05-.17-4.9-16.46-12.19-23.12-7.5-6.83-18-8.92-21.06-9.11-3.32-.21-11.81-2.15-16.87-3.3l-1-.24c-4.55-1-13.84-4-14.92-4.38l-44.79,4.83c-1,.2-37.71,7.26-41.69,12.71-2.87,3.93-8.84,20-12.4,29.65-1.85,5-2.76,7.42-3,7.85l-.07.1c-3.12,4.67-18.79,28.32-21.24,35.46-2.63,7.68-.59,14.12,5.74,18.13,5.09,3.22,10.41,2.67,13.93,2.31,1-.1,1.83-.19,2.54-.19,3,0,11.43-7,12.07-9.95s2.62-11.38,2.64-11.46a.78.78,0,0,1,0-.14L203,414.12a.53.53,0,0,1,.53-.24.5.5,0,0,1,.4.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.41,434.73a.52.52,0,0,1-.33-.12c-11.19-9.57-23.07-7.89-23.19-7.87a.51.51,0,0,1-.57-.42.49.49,0,0,1,.42-.57c.12,0,12.43-1.78,24,8.1a.5.5,0,0,1-.32.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.07,433.43c6.76-4.32,19.11-11.62,30.31-15l-4.59-9.77-12.33-22.24s-4.85-16.52-12.34-23.34-17.83-9-21.35-9.25-13-2.42-17.84-3.53-15-4.4-15-4.4L232,350.73s-34.31,5.58-42,12.92c-9.58,9.12-14.58,36.19-15.46,37.51-.4.61-4.37,6.54-8.8,13.52,4.75,3.89,15.51,11.68,28.88,15l8.77-15.35,7.48,44.92H313.73l7-42.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.73,459.79H210.89a.5.5,0,0,1-.49-.42l-7.25-43.53L195.07,430a.5.5,0,0,1-.56.24c-13.26-3.34-23.91-10.92-29.07-15.14a.5.5,0,0,1-.11-.65c3.66-5.77,7-10.87,8.72-13.4l.1-.14c.15-.26.6-2,1.07-3.83,2-7.93,6.83-26.5,14.45-33.77s40.88-12.81,42.28-13l44.95-4.85a.5.5,0,0,1,.21,0c.1,0,10.16,3.31,14.93,4.4l1,.23c5,1.15,13.47,3.08,16.72,3.28s13.91,2.31,21.66,9.38c7.37,6.71,12.1,22.29,12.46,23.51l12.3,22.2,4.61,9.79a.51.51,0,0,1,0,.42.49.49,0,0,1-.31.27c-11.24,3.41-23.73,10.84-30.18,15a.49.49,0,0,1-.39.07.54.54,0,0,1-.32-.25l-8.6-15.8-6.81,41.5A.5.5,0,0,1,313.73,459.79Zm-102.41-1h102l7-42.52a.51.51,0,0,1,.41-.41.5.5,0,0,1,.52.26l9.05,16.6c6.5-4.13,18.47-11.18,29.42-14.61l-4.34-9.25L343,386.65a.42.42,0,0,1,0-.1c-.05-.17-4.9-16.46-12.19-23.12-7.5-6.83-18-8.92-21.06-9.11-3.32-.21-11.81-2.15-16.87-3.3l-1-.24c-4.55-1-13.84-4-14.92-4.38l-44.81,4.83c-.32,0-34.23,5.63-41.73,12.78s-12.15,25.45-14.17,33.29a25.89,25.89,0,0,1-1.21,4.14l-.1.14c-1.64,2.47-4.9,7.39-8.46,13,5.16,4.17,15.35,11.3,28,14.56l8.58-15a.53.53,0,0,1,.53-.24.5.5,0,0,1,.4.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.09,384.48c-4,0-7.64-1.58-11.05-4.75-6.43-6-9.28-22.7-9.4-23.41l-1.7-5.22a.5.5,0,0,1,.31-.63l.62-.21.11,0,44.92-4.85a.5.5,0,0,1,.21,0s2.59.85,5.77,1.82a.55.55,0,0,1,.33.32l.82,2.36a.58.58,0,0,1,0,.19l-.22,4.62c-.22,4.72-3.72,15-15.4,23.5C262.73,382.4,257.67,384.48,253.09,384.48ZM232,351.26l1.57,4.82c0,.25,2.93,17.15,9.11,22.91,6.89,6.42,14.88,5.92,25.13-1.57,11.38-8.32,14.78-18.21,15-22.75l.22-4.52-.71-2c-2.72-.84-5-1.56-5.45-1.72l-44.76,4.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.34,394.61a.51.51,0,0,1-.45-.27,41.1,41.1,0,0,1-2.15-5.18.51.51,0,0,1,.31-.64.5.5,0,0,1,.63.31,40.68,40.68,0,0,0,2.1,5.06.49.49,0,0,1-.22.67A.44.44,0,0,1,235.34,394.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.76,384.54a.5.5,0,0,1-.49-.38A130.64,130.64,0,0,1,228,358.89a.52.52,0,0,1,.49-.51.48.48,0,0,1,.51.49,129.81,129.81,0,0,0,3.23,25.05.5.5,0,0,1-.36.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.46,374.36A.5.5,0,0,1,221,374c-1.56-5.82,2.06-15.74,2.22-16.16a.5.5,0,0,1,.64-.3.51.51,0,0,1,.3.64c0,.1-3.67,10.05-2.19,15.56a.5.5,0,0,1-.36.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.9,400.34a.48.48,0,0,1-.46-.32A35.57,35.57,0,0,1,305,395.2a.49.49,0,0,1,.38-.59.5.5,0,0,1,.6.38,33.41,33.41,0,0,0,1.38,4.67.5.5,0,0,1-.29.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.19,394.11a.51.51,0,0,1-.49-.41c-2.05-11-.07-23.33-.05-23.45a.5.5,0,0,1,1,.16c0,.12-2,12.24.06,23.1a.5.5,0,0,1-.4.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.87,394.61a.5.5,0,0,1-.43-.25c-2-3.54-3.93-11.25-4-11.57a.5.5,0,0,1,1-.25c0,.08,2,7.91,3.91,11.33a.49.49,0,0,1-.19.68A.54.54,0,0,1,297.87,394.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.78,416.85a.51.51,0,0,1-.29-.08l-8.59-5.95a.51.51,0,0,1-.12-.7.5.5,0,0,1,.69-.12l6.08,4.21-7.2-9.67a.5.5,0,0,1,.1-.7.51.51,0,0,1,.7.1l9,12.12a.49.49,0,0,1-.05.64A.47.47,0,0,1,320.78,416.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.41,414.87a.49.49,0,0,1-.49-.39c0-.12-2.88-12.6-4.4-18s-1.35-14.94-1.34-15.34a.49.49,0,0,1,.51-.49.5.5,0,0,1,.49.51c0,.1-.2,9.68,1.3,15.05s4.39,18,4.42,18.08a.5.5,0,0,1-.38.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.7,395.5a.5.5,0,0,1-.26-.08,24.67,24.67,0,0,1-8.56-9.46.5.5,0,0,1,.9-.43,24.19,24.19,0,0,0,8.18,9,.5.5,0,0,1,.17.68A.5.5,0,0,1,195.7,395.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.08,363.73s3.52,11.23,12.77,14.09,24-14.75,25.11-19.6a51.89,51.89,0,0,0,1.1-10.57c0-.66-1.77-16.73-1.77-16.73a179.29,179.29,0,0,1-14.75,20.25C253,361.3,239.08,363.73,239.08,363.73Z",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,378.63a8,8,0,0,1-2.31-.33c-9.39-2.91-12.95-14-13.1-14.42a.53.53,0,0,1,.05-.41.52.52,0,0,1,.34-.24c.14,0,13.8-2.51,22.17-12.38a182.13,182.13,0,0,0,14.71-20.19.48.48,0,0,1,.53-.23.49.49,0,0,1,.39.43c.18,1.65,1.77,16.12,1.77,16.79a52,52,0,0,1-1.12,10.68c-.85,3.73-8.82,13.7-16.32,18A14.61,14.61,0,0,1,254,378.63ZM239.74,364.1c.83,2.22,4.5,10.84,12.26,13.24,2.34.73,5.24.1,8.62-1.85,7.77-4.49,15.13-14.22,15.85-17.38a51.37,51.37,0,0,0,1.09-10.46c0-.48-.91-8.91-1.61-15.25a182.31,182.31,0,0,1-14,19.1C254.31,360.47,242.48,363.5,239.74,364.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.08,363.73s2.86,9.09,10.17,13c2.7-2.79,5.72-6.49,7.23-10.36,3.08-7.93,5.06-15.2,5.06-15.2C253,361.3,239.08,363.73,239.08,363.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.25,377.23a.53.53,0,0,1-.24-.06c-7.4-4-10.29-12.91-10.41-13.29a.53.53,0,0,1,.05-.41.52.52,0,0,1,.34-.24c.14,0,13.8-2.51,22.17-12.38a.5.5,0,0,1,.86.46c0,.07-2,7.38-5.08,15.24a33,33,0,0,1-7.33,10.52A.52.52,0,0,1,249.25,377.23Zm-9.51-13.13c.72,1.93,3.59,8.7,9.41,12a31.61,31.61,0,0,0,6.86-9.91c2.07-5.32,3.65-10.38,4.46-13.1C252.89,360.84,242.31,363.54,239.74,364.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.72,304.06s1.15,25.58,1.73,29.43,4.61,14.24,5.58,17.12,7.31,13.85,12.88,15.39,9.62-.58,13.28-2.31,11.93-11.35,13.46-14,4.81-9,6-11.54l1.15-2.5s1.16-24.44,1.35-27.51,2.69-15.78-.19-20.2-13.85-10.2-26-10.58S228.06,280,224,285.4,219.21,300.59,221.72,304.06Z",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.73,367a14.71,14.71,0,0,1-3.95-.55c-6-1.64-12.35-13.08-13.23-15.71-.23-.7-.65-1.86-1.16-3.25-1.59-4.38-4-11-4.44-14-.56-3.72-1.62-27.06-1.73-29.34-2.49-3.69-1.8-13.51,2.4-19.12,4.08-5.43,14.82-8.67,27.35-8.28,11.81.37,23.17,5.89,26.38,10.8,2.41,3.71,1.27,12.49.59,17.74-.16,1.22-.29,2.18-.32,2.77-.19,3-1.34,27.26-1.35,27.5a.65.65,0,0,1,0,.19l-1.16,2.5c-1.19,2.59-4.49,9-6,11.58s-9.95,12.47-13.69,14.24l-.48.23C252.26,365.64,249.33,367,245.73,367Zm3.16-89.25c-11.33,0-20.8,3-24.47,7.92-3.95,5.27-4.66,14.8-2.3,18.06a.56.56,0,0,1,.1.27c0,.26,1.15,25.61,1.72,29.39.43,2.85,2.81,9.41,4.39,13.75.51,1.41.93,2.57,1.17,3.28,1,3.08,7.29,13.62,12.55,15.07s9-.42,12.44-2l.48-.23c3.52-1.66,11.77-11.24,13.25-13.84s4.76-8.93,5.94-11.5l1.12-2.41c.08-1.7,1.16-24.48,1.34-27.42,0-.63.17-1.6.33-2.84.62-4.77,1.77-13.66-.44-17.06-2.6-4-13.2-10-25.57-10.35C250.25,277.79,249.57,277.78,248.89,277.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25,302.13c0-1.34,2.31-1.73,2.31-1.73s11.93,9,19.05,8.66,15.77-6.73,19-6.16,3.66,3.47,2.7,8.27-1.54,11.74,0,11.93,4.23-1,4.23-1-.39,5,1.54,5.19,3.65-2.11,3.65-2.69.58-8.27.58-8.27l.35-.17c.19-3.9.36-7.11.42-8.1.19-3.08,2.69-15.78-.19-20.2s-13.85-10.2-26-10.58S228.06,280,224,285.4s-4.81,15.19-2.3,18.66C221.72,304.06,223.25,303.48,223.25,302.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.34,327.84h-.27c-1.89-.19-2.06-3.33-2-4.95a9.51,9.51,0,0,1-3.76.72,1.08,1.08,0,0,1-.76-.49c-1.33-1.84-.21-9.31.34-12,.65-3.27.59-5.33-.2-6.48a3,3,0,0,0-2.09-1.2c-1.36-.24-4.08,1-7,2.3-3.77,1.71-8,3.64-12,3.86-6.83.37-17.6-7.44-19.19-8.62-.59.14-1.69.53-1.69,1.19a2.79,2.79,0,0,1-1.86,2.39.5.5,0,0,1-.58-.17c-2.6-3.6-1.94-13.58,2.31-19.25,4.08-5.43,14.82-8.67,27.35-8.28,11.81.37,23.17,5.89,26.38,10.8,2.41,3.71,1.27,12.49.59,17.74-.16,1.22-.29,2.18-.32,2.77-.06,1-.23,4.2-.42,8.09a.49.49,0,0,1-.28.43l-.09.05c-.18,2.31-.56,7.5-.56,7.94a3.73,3.73,0,0,1-1.32,2.05A4,4,0,0,1,272.34,327.84Zm-1.76-6.2a.5.5,0,0,1,.5.54c-.14,1.82.11,4.56,1.09,4.66,1.59.15,3-1.8,3.1-2.22s.52-7.5.58-8.29a.49.49,0,0,1,.28-.41l.09,0c.18-3.77.34-6.85.4-7.81,0-.63.17-1.6.33-2.84.62-4.77,1.77-13.66-.44-17.06-2.6-4-13.2-10-25.57-10.35s-22.63,2.7-26.52,7.88-4.61,14.15-2.53,17.71a1.58,1.58,0,0,0,.86-1.28c0-1.39,1.72-2.05,2.73-2.22a.49.49,0,0,1,.39.09c.11.09,11.85,8.95,18.71,8.56,3.75-.2,7.93-2.1,11.61-3.77,3.29-1.49,5.89-2.67,7.55-2.38a4,4,0,0,1,2.75,1.63c1,1.4,1.07,3.63.35,7.23-1,5.08-1.25,10.23-.51,11.26l.08.08a10.36,10.36,0,0,0,4-.93A.45.45,0,0,1,270.58,321.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.92,328.68s1.93-9.23,5.39-8.85,3.08,9.24.77,12.51-4.62,3.84-4.62,3.84",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.46,336.68a.5.5,0,0,1-.48-.38.49.49,0,0,1,.36-.6s2.18-.6,4.33-3.65c1.68-2.37,2.24-7.8,1.08-10.38a2,2,0,0,0-1.49-1.34c-2.5-.28-4.37,6.17-4.85,8.45a.5.5,0,1,1-1-.2c.2-1,2.14-9.65,5.93-9.25a2.89,2.89,0,0,1,2.29,1.93c1.3,2.88.7,8.72-1.17,11.36-2.39,3.39-4.8,4-4.91,4.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.45,350.15c-4.32,0-5.43-2.32-5.66-3-.4-1.18.07-13,.16-15.37a.5.5,0,0,1,1,0c-.22,5.37-.47,14.2-.22,15s1.17,2.35,4.72,2.35,4.09-1,4.53-2.35a.5.5,0,0,1,.63-.32.49.49,0,0,1,.32.63C248.29,349,247.19,350.15,243.45,350.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.69,355.35a26.56,26.56,0,0,1-6.4-.61,7.88,7.88,0,0,1-3.33-2.69.5.5,0,0,1,.13-.69.49.49,0,0,1,.69.12,7.07,7.07,0,0,0,2.83,2.31c1.63.54,6.92.75,9.58.37a10.73,10.73,0,0,0,5.24-2.29.5.5,0,0,1,.69-.14.51.51,0,0,1,.14.7c-.49.73-3.11,2.31-5.93,2.72A27.55,27.55,0,0,1,244.69,355.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.85,328.83s11.2-.6,12.53-.81-3.46-2.18-7.54-2.12S244.83,327,247.85,328.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.85,329.33a.59.59,0,0,1-.26-.07c-1-.63-1.45-1.28-1.27-1.94.47-1.7,5.11-1.9,6.52-1.92,3.1-.08,8.17,1.27,8.27,2.43,0,.06,0,.58-.65.68-1.34.22-12.12.79-12.58.82ZM253,326.4h-.18c-3.43.05-5.44.72-5.56,1.19,0,.07.07.32.69.73,1.18-.06,8.49-.46,11.32-.69A18.15,18.15,0,0,0,253,326.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.1,328.77s-11.21-.49-12.54-.68,3.44-2.22,7.52-2.2S240.1,326.88,237.1,328.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.1,329.27h0c-.46,0-11.25-.49-12.59-.69-.68-.1-.66-.62-.66-.67.09-1.16,5.09-2.52,8.2-2.52h.05c1.41,0,6,.16,6.53,1.86.19.65-.23,1.31-1.25,1.94A.42.42,0,0,1,237.1,329.27Zm-11.46-1.59c2.87.21,10.15.53,11.32.58.62-.41.71-.67.69-.74-.13-.46-2.14-1.11-5.57-1.13H232A18.41,18.41,0,0,0,225.64,327.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.86,337.48a6,6,0,0,1-5-2.17.51.51,0,0,1,.14-.7.5.5,0,0,1,.69.14h0c.09.13,2.21,3.1,8.07,1a.5.5,0,0,1,.64.3.49.49,0,0,1-.3.64A12.39,12.39,0,0,1,232.86,337.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,338.43a6.2,6.2,0,0,1-5-2.16.48.48,0,0,1,.1-.69.5.5,0,0,1,.7.1c.12.15,2.79,3.55,9.11.42a.5.5,0,1,1,.44.9A12.19,12.19,0,0,1,254,338.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.24,
    y: 401.03,
    width: 24.29,
    height: 48.88,
    transform: "translate(-234.96 392.27) rotate(-54.25)",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.13,450.1a.48.48,0,0,1-.29-.09l-39.68-28.56a.54.54,0,0,1-.2-.33.49.49,0,0,1,.09-.37L252.24,401a.5.5,0,0,1,.7-.11l39.67,28.56a.48.48,0,0,1,.11.69L278.53,449.9a.49.49,0,0,1-.32.2Zm-39-29.17,38.86,28L291.62,430l-38.86-28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.93,
    y: 404.74,
    width: 16.91,
    height: 41.46,
    transform: "translate(-234.96 392.27) rotate(-54.25)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.27,444.94a.5.5,0,0,1-.29-.09l-33.65-24.23a.5.5,0,0,1-.11-.69l9.88-13.73a.5.5,0,0,1,.7-.11l33.64,24.22a.5.5,0,0,1,.12.7l-9.88,13.72a.5.5,0,0,1-.33.2Zm-32.95-24.83,32.84,23.63,9.29-12.91-32.83-23.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.63,422.35c2.62,1.88,3.74,4.81,2.5,6.53s-4.37,1.59-7-.29-3.73-4.81-2.49-6.53S265,420.46,267.63,422.35Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.37,430.58a7.91,7.91,0,0,1-4.52-1.59,8.18,8.18,0,0,1-2.87-3.55,3.5,3.5,0,0,1,3.66-5.09,8.12,8.12,0,0,1,4.28,1.59c2.84,2.05,4,5.29,2.61,7.23A3.74,3.74,0,0,1,267.37,430.58Zm-4-9.24a2.78,2.78,0,0,0-2.35,1,2.86,2.86,0,0,0-.14,2.73,7.1,7.1,0,0,0,2.52,3.1c2.39,1.72,5.22,1.9,6.29.41s0-4.11-2.38-5.83a7.06,7.06,0,0,0-3.74-1.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.09,
    y: 398.67,
    width: 24.29,
    height: 48.88,
    transform: "translate(-222.49 324.53) rotate(-46.19)",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.46,449.29a.48.48,0,0,1-.34-.14l-35.28-33.84a.49.49,0,0,1,0-.7l16.82-17.53a.5.5,0,0,1,.35-.16.48.48,0,0,1,.35.14l35.28,33.84a.5.5,0,0,1,0,.71l-16.82,17.53a.49.49,0,0,1-.35.15Zm-34.57-34.35,34.56,33.14,16.12-16.8L260,398.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.77,
    y: 402.38,
    width: 16.91,
    height: 41.46,
    transform: "translate(-222.49 324.53) rotate(-46.19)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.34,444.06a.5.5,0,0,1-.35-.14l-29.92-28.7a.5.5,0,0,1,0-.71l11.7-12.2a.47.47,0,0,1,.35-.15.53.53,0,0,1,.36.13L290.39,431a.5.5,0,0,1,0,.71l-11.7,12.2a.48.48,0,0,1-.35.16Zm-29.22-29.21,29.2,28,11-11.48-29.2-28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.89,420.33c2.33,2.24,3,5.29,1.56,6.82s-4.55,1-6.88-1.27-3-5.28-1.56-6.82S269.56,418.1,271.89,420.33Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.21,428.51a5.56,5.56,0,0,1-1-.09,8.09,8.09,0,0,1-4-2.18c-2.52-2.42-3.22-5.79-1.57-7.52s5.06-1.17,7.59,1.25,3.22,5.8,1.57,7.53A3.48,3.48,0,0,1,271.21,428.51Zm-3.95-9.82a2.53,2.53,0,0,0-1.89.72c-1.27,1.33-.58,4.07,1.55,6.11a7.15,7.15,0,0,0,3.5,1.92,2.85,2.85,0,0,0,2.66-.63c1.28-1.34.59-4.08-1.54-6.12A6.6,6.6,0,0,0,267.26,418.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.81,
    y: 397.39,
    width: 24.29,
    height: 48.88,
    transform: "translate(-196.14 241.85) rotate(-36.1)",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.54,449.23a.51.51,0,0,1-.4-.2l-28.8-39.5a.5.5,0,0,1,.1-.7l19.63-14.31a.48.48,0,0,1,.37-.09.5.5,0,0,1,.33.2l28.8,39.49a.52.52,0,0,1,.09.38.46.46,0,0,1-.2.32l-19.62,14.32A.53.53,0,0,1,277.54,449.23Zm-28.1-39.88L277.65,448l18.82-13.72-28.22-38.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.5,
    y: 401.1,
    width: 16.91,
    height: 41.46,
    transform: "translate(-196.14 241.85) rotate(-36.1)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.34,444.06h-.08a.5.5,0,0,1-.33-.2L253.5,410.36a.51.51,0,0,1,.11-.7l13.67-10a.53.53,0,0,1,.37-.09.49.49,0,0,1,.32.2l24.43,33.5a.49.49,0,0,1-.11.7l-13.66,10A.45.45,0,0,1,278.34,444.06Zm-23.73-33.89,23.84,32.69,12.85-9.37L267.46,400.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.06,419.56c1.9,2.61,2.05,5.74.34,7s-4.65.15-6.55-2.46-2.05-5.73-.34-7S274.16,417,276.06,419.56Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.72,427.57a4.87,4.87,0,0,1-1.7-.33,8.13,8.13,0,0,1-3.58-2.85c-2.06-2.83-2.16-6.27-.22-7.69a3.83,3.83,0,0,1,3.67-.28,8,8,0,0,1,3.57,2.85h0c2.06,2.82,2.17,6.27.23,7.68A3.28,3.28,0,0,1,274.72,427.57Zm-3.53-10.48a2.28,2.28,0,0,0-1.38.42c-1.49,1.09-1.29,3.91.44,6.29a7.08,7.08,0,0,0,3.12,2.5,2.83,2.83,0,0,0,2.73-.16c1.49-1.08,1.29-3.9-.45-6.28a7.06,7.06,0,0,0-3.11-2.5A3.86,3.86,0,0,0,271.19,417.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.51,
    y: 396.74,
    width: 24.29,
    height: 48.88,
    transform: "translate(-146.99 148.85) rotate(-23.93)",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.47,449a.51.51,0,0,1-.46-.3L256.18,404a.55.55,0,0,1,0-.38.5.5,0,0,1,.27-.28l22.2-9.85a.49.49,0,0,1,.66.25l19.83,44.68a.52.52,0,0,1,0,.39.48.48,0,0,1-.27.27l-22.2,9.86A.65.65,0,0,1,276.47,449ZM257.3,404l19.43,43.77L298,438.34l-19.42-43.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.2,
    y: 400.45,
    width: 16.91,
    height: 41.46,
    transform: "translate(-146.99 148.85) rotate(-23.93)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.34,444.06a.57.57,0,0,1-.18,0,.5.5,0,0,1-.28-.27l-16.82-37.89a.58.58,0,0,1,0-.39.48.48,0,0,1,.27-.27l15.45-6.86a.49.49,0,0,1,.66.25l16.82,37.9a.51.51,0,0,1-.25.66L278.54,444A.65.65,0,0,1,278.34,444.06Zm-16.16-38.14,16.41,37,14.54-6.46-16.41-37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.17,419.62c1.31,2.95.8,6-1.14,6.9s-4.58-.83-5.89-3.78-.79-6,1.15-6.9S279.86,416.67,281.17,419.62Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.94,427.25a4.4,4.4,0,0,1-2.36-.77,8,8,0,0,1-2.89-3.54c-1.42-3.19-.8-6.58,1.39-7.56s5.13.84,6.55,4h0a8.12,8.12,0,0,1,.68,4.52,3.83,3.83,0,0,1-2.08,3A3.17,3.17,0,0,1,278.94,427.25Zm-2.56-11.14a2.09,2.09,0,0,0-.89.19c-1.69.75-2.08,3.55-.89,6.24a7,7,0,0,0,2.52,3.1,2.52,2.52,0,0,0,4.2-1.87,7,7,0,0,0-.61-3.94C279.72,417.58,277.93,416.11,276.38,416.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.85,
    y: 397.03,
    width: 24.29,
    height: 48.88,
    transform: "translate(-86.32 72.9) rotate(-12.79)",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.56,448.5a.5.5,0,0,1-.26-.08.48.48,0,0,1-.23-.31l-10.82-47.67a.5.5,0,0,1,.38-.6l23.68-5.38a.5.5,0,0,1,.38.06.52.52,0,0,1,.22.32l10.82,47.67a.49.49,0,0,1-.37.6l-23.69,5.37Zm-10.22-47.8,10.6,46.7,22.71-5.16-10.6-46.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.54,
    y: 400.74,
    width: 16.91,
    height: 41.46,
    transform: "translate(-86.32 72.9) rotate(-12.79)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.34,444.06a.51.51,0,0,1-.49-.39l-9.18-40.43a.5.5,0,0,1,.38-.6l16.49-3.74a.51.51,0,0,1,.6.37l9.17,40.43a.49.49,0,0,1-.37.6l-16.49,3.75Zm-8.58-40.55L278.71,443l15.52-3.52-9-39.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.74,420.62c.71,3.15-.38,6.08-2.45,6.55s-4.33-1.7-5.05-4.85.39-6.08,2.46-6.55S285,417.47,285.74,420.62Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.73,427.73c-2.13,0-4.27-2.21-5-5.3a8,8,0,0,1,.2-4.56,3.51,3.51,0,0,1,6.11-1.39,8,8,0,0,1,2.16,4,8.21,8.21,0,0,1-.2,4.56,3.84,3.84,0,0,1-2.63,2.59A3.11,3.11,0,0,1,282.73,427.73Zm-1.46-11.52a2.4,2.4,0,0,0-.46.05,2.86,2.86,0,0,0-1.91,2,7.11,7.11,0,0,0-.17,4c.65,2.87,2.65,4.88,4.44,4.47a2.83,2.83,0,0,0,1.92-2,7,7,0,0,0,.16-4h0a7.07,7.07,0,0,0-1.87-3.53A3.11,3.11,0,0,0,281.27,416.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.72,426.48s-17.39,6.61-18.27,7.27-9.47,8.59-9.91,9.69l-.44,1.1a1.29,1.29,0,0,0,1.32,1.54s-1.76,2.64-.22,4,3.74.22,3.74.22-2,3.08.22,3.74a13.7,13.7,0,0,0,5.07.22s-.44,1.1,7.26,2.64,15.86,2.2,19.38,1.54,11.45-1.54,11.45-1.54,35.23,2.86,42.28,2.2,18.28.44,20.48-3.08-1.1-9.91-3.75-13.87-8.8-11.45-16.07-11.67a46.16,46.16,0,0,0-16.07,3.08c-4,1.76-13.22,5.51-14.1,5.73s-10.35-.44-10.35-.44-18.27-12.12-19.37-12.34A9.64,9.64,0,0,0,295.72,426.48Z",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.55,459.67c-10.79,0-38-2.2-39.27-2.3,0,0-7.85.89-11.32,1.53s-11.77,0-19.57-1.54c-4.3-.86-6.82-1.73-7.48-2.59a13.47,13.47,0,0,1-4.89-.28,1.82,1.82,0,0,1-1.27-1.12,3.27,3.27,0,0,1,.21-2.26,3.58,3.58,0,0,1-3.09-.69c-1.35-1.15-.71-3-.23-4A1.55,1.55,0,0,1,267,446a2.09,2.09,0,0,1-.42-1.54l0-.12.44-1.1c.53-1.32,9.55-9.5,10.08-9.9.89-.67,15.48-6.23,18.4-7.33a.19.19,0,0,1,.1,0,10.07,10.07,0,0,1,2.81,0c1.13.23,16.14,10.15,19.45,12.34,4.49.31,9.51.57,10.06.44.82-.2,10-3.92,14-5.7A46.65,46.65,0,0,1,358.27,430c8.1.24,14.66,9.16,16.48,11.89,2,3,6.31,10.32,3.75,14.42-1.73,2.77-8.14,2.9-14.34,3-2.35,0-4.58.1-6.51.28C356.9,459.64,355.84,459.67,354.55,459.67Zm-39.29-3.29c.45,0,35.37,2.85,42.29,2.2,2-.19,4.22-.24,6.59-.29,5.66-.11,12.07-.25,13.51-2.56,2.25-3.6-1.86-10.53-3.73-13.33-1.75-2.63-8.06-11.22-15.68-11.45a45.29,45.29,0,0,0-15.85,3c-3.82,1.7-13.23,5.51-14.18,5.75s-8.91-.32-10.5-.43a.41.41,0,0,1-.24-.08c-7.2-4.77-18.26-12-19.22-12.26a9.29,9.29,0,0,0-2.4,0c-6.92,2.63-17.41,6.69-18.11,7.18-1.13.86-9.32,8.52-9.74,9.48l-.41,1a1,1,0,0,0,.19.7.79.79,0,0,0,.64.22.5.5,0,0,1,.44.27.47.47,0,0,1,0,.51s-1.49,2.29-.31,3.31,3.18.16,3.2.15a.49.49,0,0,1,.59.11.51.51,0,0,1,.05.61c-.26.41-.95,1.75-.67,2.48a.79.79,0,0,0,.61.51,13.41,13.41,0,0,0,4.85.21.49.49,0,0,1,.47.18.45.45,0,0,1,.1.27c.15.18,1.15,1.05,6.87,2.19,7.68,1.54,15.75,2.18,19.19,1.54S315.19,456.38,315.26,456.38Zm-37.57-2h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0h0Zm0,0Zm0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.42,446.58a.49.49,0,0,1-.44-.26.51.51,0,0,1,.2-.68l13.43-7.26.12-.05,15.19-3.74a.5.5,0,0,1,.61.36.5.5,0,0,1-.37.61L282,439.29l-13.37,7.23A.53.53,0,0,1,268.42,446.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.94,450.77a.52.52,0,0,1-.47-.33.5.5,0,0,1,.3-.64l12.55-4.63,13.95-2.66a.5.5,0,1,1,.19,1l-13.87,2.64-12.48,4.6A.33.33,0,0,1,271.94,450.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.23,454.73a.5.5,0,0,1-.07-1L289.49,452l11-1.32a.5.5,0,0,1,.12,1l-11,1.32-12.32,1.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.78,428.46s10.57,5.29,11.67,5.51,7.93-.22,8.37,4.62-4,11.45-4.84,14.31-11.23,2.2-11.23,2.2-3.53-11.89-4.41-16.29S174.78,428.46,174.78,428.46Z",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.44,455.69c-1.23,0-2.24-.06-2.73-.09a.48.48,0,0,1-.44-.35c0-.12-3.54-12-4.42-16.34s.39-10.31.44-10.56a.51.51,0,0,1,.28-.34.49.49,0,0,1,.44,0c4.06,2,10.79,5.31,11.54,5.47a7.77,7.77,0,0,0,.78.06c2.27.14,7.57.46,8,5,.32,3.54-1.82,7.94-3.38,11.15a30.16,30.16,0,0,0-1.49,3.36C189.76,455.3,184.78,455.69,181.44,455.69Zm-2.31-1.06c3.86.2,9.83-.12,10.37-1.88a28.28,28.28,0,0,1,1.54-3.5c1.51-3.1,3.58-7.36,3.28-10.62-.33-3.68-4.87-4-7-4.09-.42,0-.74-.05-.92-.08-1-.21-8.82-4.07-11.21-5.26-.3,1.63-1,6.09-.31,9.51C175.61,442.63,178.55,452.66,179.13,454.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.6 410.18 183.37 452.24 187.18 455.99 187.08 450.48 173.98 409 170.6 410.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.18,456.49a.47.47,0,0,1-.35-.15L183,452.6a.57.57,0,0,1-.13-.21l-12.77-42.06a.5.5,0,0,1,.31-.62l3.39-1.18a.45.45,0,0,1,.39,0,.48.48,0,0,1,.25.29l13.1,41.48a.78.78,0,0,1,0,.14l.1,5.51a.51.51,0,0,1-.31.47A.65.65,0,0,1,187.18,456.49ZM183.81,452l2.85,2.8-.08-4.21-12.92-40.92-2.44.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.98 409 170.6 410.18 172.1 415.13 175.55 413.96 173.98 409",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1,415.63a.46.46,0,0,1-.23-.06.5.5,0,0,1-.25-.3l-1.5-4.94a.5.5,0,0,1,.31-.62l3.39-1.18a.45.45,0,0,1,.39,0,.48.48,0,0,1,.25.29l1.57,5a.51.51,0,0,1-.32.63l-3.45,1.16A.45.45,0,0,1,172.1,415.63Zm-.88-5.13,1.21,4,2.5-.84-1.27-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.39,452.9s1.32,3.75,2.64,4.19,8.81.22,11,.22S157.39,452.9,157.39,452.9Z",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.13,457.86a25.07,25.07,0,0,1-5.26-.3c-1.48-.49-2.72-3.83-3-4.49a.5.5,0,0,1,.11-.51.49.49,0,0,1,.5-.14c14.35,4,14.3,4.37,14.22,4.9,0,.18-.15.49-.7.49l-1.91,0Zm5.76-.28h0Zm-12.67-3.93c.56,1.32,1.36,2.76,2,3,.94.32,5.9.26,8.72.22C166.31,456,161.72,454.64,158.22,453.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.47,444.54s-3.52,6.6-3.08,8.36,3.74,2.65,6.6,3.31a58,58,0,0,0,12.33.66c2.87-.22-2.42-2.87-2.42-2.87a77.79,77.79,0,0,1-8.15-5.72A29.24,29.24,0,0,0,160.47,444.54Z",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.62,457.45a53.93,53.93,0,0,1-9.74-.76c-3.26-.75-6.48-1.65-7-3.67-.46-1.85,2.52-7.59,3.13-8.72a.48.48,0,0,1,.66-.21,29.5,29.5,0,0,1,5.39,3.81,77.41,77.41,0,0,0,8.08,5.68c2.46,1.22,3.65,2.25,3.5,3s-1,.75-1.3.78C175.65,457.42,174.7,457.45,173.62,457.45Zm-13-12.23c-1.31,2.53-3.07,6.48-2.8,7.56.4,1.59,4.19,2.47,6.23,2.94a57.52,57.52,0,0,0,12.18.65l.3,0a12.3,12.3,0,0,0-2.9-1.88,75.81,75.81,0,0,1-8.25-5.79A32.43,32.43,0,0,0,160.67,445.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.63,438.15s-5.94,4-6.16,6.39,6.38,8.8,7.49,9.68,8.8,2.87,11.23,2.43a4.65,4.65,0,0,0,3.3-2.21s-7.49-5.72-9.47-8.8a76.43,76.43,0,0,1-4.4-8.81Z",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.35,457.21c-3.14,0-9.59-1.7-10.71-2.6-.08-.06-7.94-7.09-7.67-10.12.24-2.59,5.76-6.34,6.39-6.76l2-1.32a.52.52,0,0,1,.42-.06.52.52,0,0,1,.32.28,75.32,75.32,0,0,0,4.36,8.74c1.91,3,9.28,8.62,9.35,8.68a.51.51,0,0,1,.15.62,5.16,5.16,0,0,1-3.66,2.47A5.11,5.11,0,0,1,178.35,457.21Zm-11.72-19.06.28.42c-1.6,1.06-5.78,4.22-5.94,6-.18,2,5.73,8,7.3,9.25.91.73,8.49,2.75,10.83,2.32a4.28,4.28,0,0,0,2.72-1.59c-1.55-1.21-7.45-5.89-9.22-8.65a72.41,72.41,0,0,1-4.21-8.33l-1.48,1Zm0,0h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.78,428.46s-8.59,2.2-8.59,5.29,3.75,12.33,5.73,14.31,8.81,7.93,10.57,6.38.66-3.08.22-4.62-5.51-14.53-5.51-14.53Z",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.74,455.18c-3.3,0-10.1-6.69-10.17-6.77-2.09-2.08-5.88-11.54-5.88-14.66,0-3.38,8.05-5.54,9-5.77a.49.49,0,0,1,.59.31l2.42,6.83c.21.52,5.08,13,5.52,14.56.08.28.18.56.28.84.46,1.26,1,2.82-.65,4.3A1.6,1.6,0,0,1,181.74,455.18Zm-7.28-26.12c-3.17.88-7.77,2.81-7.77,4.69,0,2.89,3.65,12,5.58,14,3.19,3.18,8.76,7.34,9.89,6.36s.82-2,.37-3.21c-.11-.3-.22-.6-.3-.9-.43-1.5-5.44-14.36-5.49-14.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.65,434.85s-7.26,13.65-5.94,15,3.74,2.64,4.84,2,5.73-6.6,7-9.91.44-4.62-1.54-6.16A5.44,5.44,0,0,0,188.65,434.85Z",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.82,452.48c-1.47,0-3.39-1.23-4.46-2.31-1.38-1.37,3.07-10.34,5.85-15.56a.55.55,0,0,1,.31-.25,5.93,5.93,0,0,1,4.85,1c2.17,1.69,3.09,3.27,1.69,6.75-1.31,3.28-5.93,9.36-7.25,10.15A1.92,1.92,0,0,1,186.82,452.48ZM189,435.29c-3.26,6.13-6.41,13.25-5.91,14.2,1.36,1.35,3.49,2.32,4.22,1.88.92-.55,5.5-6.32,6.84-9.66,1.18-3,.56-4.07-1.39-5.59A4.89,4.89,0,0,0,189,435.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.47,459.63a2.81,2.81,0,1,1,2.8-2.81A2.8,2.8,0,0,1,206.47,459.63Zm0-4.61a1.81,1.81,0,1,0,1.8,1.8A1.81,1.81,0,0,0,206.47,455Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.64,
    y: 456.06,
    width: 62.24,
    height: 3.28,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.87,459.84H143.64a.5.5,0,0,1-.5-.5v-3.28a.5.5,0,0,1,.5-.5h62.23a.5.5,0,0,1,.5.5v3.28A.5.5,0,0,1,205.87,459.84Zm-61.73-1h61.23v-2.28H144.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.26,
    y: 456.06,
    width: 62.24,
    height: 3.28,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.5,459.84H207.26a.5.5,0,0,1-.5-.5v-3.28a.5.5,0,0,1,.5-.5H269.5a.51.51,0,0,1,.5.5v3.28A.51.51,0,0,1,269.5,459.84Zm-61.74-1H269v-2.28H207.76Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.81,459.84h-9.26a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h9.26a.5.5,0,0,1,.5.5A.5.5,0,0,1,406.81,459.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.56,459.84H66.13a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H392.56a.5.5,0,0,1,.5.5A.5.5,0,0,1,392.56,459.84Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.48,157l-45.25-41.85a61.64,61.64,0,1,0,97.09,75.21Z",
    style: {
      fill: "#878787"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.48,219.12a62.14,62.14,0,0,1-45.62-104.35.5.5,0,0,1,.71,0l45.22,41.83,51.8,33.32a.51.51,0,0,1,.22.32.47.47,0,0,1-.07.38A62,62,0,0,1,247.48,219.12ZM202.26,115.81a61.14,61.14,0,1,0,96.37,74.65l-51.42-33.08-.07,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.23,115.11,247.48,157l51.84,33.36a61.64,61.64,0,0,0-97.09-75.21Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.32,190.81a.54.54,0,0,1-.27-.07l-51.84-33.36-45.32-41.91a.49.49,0,0,1,0-.7,62.14,62.14,0,0,1,97.88,75.82A.5.5,0,0,1,299.32,190.81Zm-96.38-75.73,44.88,41.52,51.35,33a61.14,61.14,0,0,0-96.23-74.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.48,157l-14.35,60a61.59,61.59,0,0,0,66.19-26.6Z",
    style: {
      fill: "#b8b8b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.48,219.12A62.75,62.75,0,0,1,233,217.41a.52.52,0,0,1-.31-.23.5.5,0,0,1-.06-.38l14.36-60a.46.46,0,0,1,.3-.35.51.51,0,0,1,.45,0l51.84,33.35a.51.51,0,0,1,.22.32.47.47,0,0,1-.07.38A62,62,0,0,1,247.48,219.12Zm-13.75-2.57a61.1,61.1,0,0,0,64.9-26.09L247.8,157.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.05,216.9,247.48,157l-61.63-1c0,.33,0,.64,0,1A61.67,61.67,0,0,0,233.05,216.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.05,217.4h-.12A61.93,61.93,0,0,1,185.33,157c0-.19,0-.38,0-.57V156a.49.49,0,0,1,.15-.35.75.75,0,0,1,.36-.15l61.63,1a.55.55,0,0,1,.39.2.52.52,0,0,1,.09.42L233.54,217A.5.5,0,0,1,233.05,217.4Zm-46.71-60.89c0,.15,0,.3,0,.45a60.93,60.93,0,0,0,46.35,59.34l14.17-58.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.73,132.72a.5.5,0,0,1-.31-.9l30-23a.5.5,0,0,1,.61.8l-30,23A.47.47,0,0,1,287.73,132.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.61,209.74a.5.5,0,0,1-.29-.9l27.28-19.79a.5.5,0,1,1,.58.81l-27.27,19.79A.55.55,0,0,1,178.61,209.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.68,136.46a.52.52,0,0,1-.21,0l-35.3-16a.5.5,0,0,1-.25-.66.51.51,0,0,1,.67-.25l35.3,16a.5.5,0,0,1,.25.66A.52.52,0,0,1,202.68,136.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.35,237.47H278.64a.51.51,0,0,1-.47-.32L264.8,203a.5.5,0,0,1,.28-.65.51.51,0,0,1,.65.28L279,236.47h23.37a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.48,
    cy: 156.96,
    r: 42.16,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.48,199.62A42.66,42.66,0,1,1,290.14,157,42.7,42.7,0,0,1,247.48,199.62Zm0-84.31A41.66,41.66,0,1,0,289.14,157,41.7,41.7,0,0,0,247.48,115.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.36,185.8v-4.74q-5.82-.23-8.66-3.78t-3.13-10.09l7.22-1.42a23.19,23.19,0,0,0,.62,4.69,6.54,6.54,0,0,0,1.61,3.13,3.93,3.93,0,0,0,2.9,1.1,3.34,3.34,0,0,0,2.91-1.21,5.17,5.17,0,0,0,.87-3.08,8.22,8.22,0,0,0-1.38-4.91,23.2,23.2,0,0,0-3.58-3.83l-5.81-5.08a21.22,21.22,0,0,1-2.77-3,12.48,12.48,0,0,1-1.86-3.5,13.86,13.86,0,0,1-.68-4.54q0-5.13,2.94-8a11.72,11.72,0,0,1,7.9-3.19v-4.57h2.42v4.51a10.57,10.57,0,0,1,4.74,1.27,8.8,8.8,0,0,1,3,2.82,12.91,12.91,0,0,1,1.64,3.87,23.05,23.05,0,0,1,.65,4.46L250.76,148a29.48,29.48,0,0,0-.45-3.87,5.44,5.44,0,0,0-1.27-2.71,3.32,3.32,0,0,0-2.74-.87,3.7,3.7,0,0,0-2.9,1.24,4.51,4.51,0,0,0-1,3,6.59,6.59,0,0,0,1.07,3.92,19.81,19.81,0,0,0,2.65,3l5.76,5a31.31,31.31,0,0,1,3.35,3.55,16.06,16.06,0,0,1,2.49,4.29,14.71,14.71,0,0,1,.93,5.41,11.91,11.91,0,0,1-1.22,5.45A9.86,9.86,0,0,1,254,179.2a11.64,11.64,0,0,1-5.25,1.81v4.79Z",
    style: {
      fill: "#DAC7FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bills--inject-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.81,
    y: 195.48,
    width: 62.26,
    height: 83.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.45,279.19h-63V195.1h63Zm-62.26-.75H164.7V195.85H103.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.17,
    y: 220.59,
    width: 48.04,
    height: 0.75,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.17,
    y: 232.36,
    width: 48.04,
    height: 0.75,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.17,
    y: 268.64,
    width: 48.04,
    height: 0.75,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.7,
    y: 221.46,
    width: 0.75,
    height: 50.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.72,
    y: 221.46,
    width: 0.75,
    height: 50.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.94,
    y: 221.46,
    width: 0.75,
    height: 50.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.11,215.6v-12h3a6.37,6.37,0,0,1,1.44.15,2.81,2.81,0,0,1,1.11.49,2.28,2.28,0,0,1,.72.94,3.82,3.82,0,0,1,.25,1.5,3.54,3.54,0,0,1-.2,1.24,1.85,1.85,0,0,1-.58.82,2.2,2.2,0,0,1-1,.41,2.4,2.4,0,0,1,1.18.5,2.29,2.29,0,0,1,.7,1,4.18,4.18,0,0,1,.23,1.46,5,5,0,0,1-.22,1.52,2.77,2.77,0,0,1-.63,1.1,2.8,2.8,0,0,1-1.06.66,4.64,4.64,0,0,1-1.47.22Zm2.19-7.09H122a2.27,2.27,0,0,0,1-.19,1.07,1.07,0,0,0,.5-.6,3.12,3.12,0,0,0,.14-1,1.91,1.91,0,0,0-.22-1,1.07,1.07,0,0,0-.64-.47,3.76,3.76,0,0,0-1.1-.13h-.43Zm0,5.55h.83a1.6,1.6,0,0,0,1.35-.48,2.5,2.5,0,0,0,.35-1.49,3.27,3.27,0,0,0-.17-1.18,1.24,1.24,0,0,0-.56-.67,2.09,2.09,0,0,0-1-.22h-.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.42,215.6v-12h2.16v12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.43,215.6v-12h2.19v10.48h2.9v1.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6,215.6v-12h2.19v10.48h2.9v1.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,215.76a3.54,3.54,0,0,1-1.81-.42,2.62,2.62,0,0,1-1.1-1.24,5.45,5.45,0,0,1-.41-2l1.88-.36a6,6,0,0,0,.17,1.22,1.81,1.81,0,0,0,.43.83,1,1,0,0,0,.76.28.86.86,0,0,0,.76-.31,1.48,1.48,0,0,0,.22-.81,2.18,2.18,0,0,0-.36-1.29,5.75,5.75,0,0,0-.94-1l-1.51-1.33a4.34,4.34,0,0,1-1-1.22,3.38,3.38,0,0,1-.38-1.67,2.87,2.87,0,0,1,.83-2.19,3.23,3.23,0,0,1,2.27-.77,3.36,3.36,0,0,1,1.4.26,2.32,2.32,0,0,1,.9.72,3.4,3.4,0,0,1,.5,1.05,6.72,6.72,0,0,1,.2,1.23l-1.86.33a5.77,5.77,0,0,0-.13-1,1.4,1.4,0,0,0-.34-.7,1,1,0,0,0-.72-.25.9.9,0,0,0-.74.32,1.18,1.18,0,0,0-.26.79,1.79,1.79,0,0,0,.25,1,4.28,4.28,0,0,0,.72.81l1.5,1.32a6.26,6.26,0,0,1,1.26,1.45,3.76,3.76,0,0,1,.53,2,3,3,0,0,1-.38,1.52,2.69,2.69,0,0,1-1,1A3.07,3.07,0,0,1,146.8,215.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.61,
    y: 191.04,
    width: 62.26,
    height: 83.34,
    transform: "translate(54.25 -22.38) rotate(12.69)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.23,280.65l-.36-.08L87.76,266.8l.09-.36,18.39-81.67,61.47,13.84ZM88.66,266.24l60,13.51,18.15-80.57-60-13.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 192.96,
    width: 0.75,
    height: 48.04,
    transform: "translate(-109.04 297.62) rotate(-77.31)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 204.43,
    width: 0.75,
    height: 48.05,
    transform: "translate(-122.26 304.05) rotate(-77.31)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.36,
    y: 216.26,
    width: 0.75,
    height: 48.05,
    transform: "translate(-135.52 311.13) rotate(-77.31)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.16,
    y: 228.09,
    width: 0.75,
    height: 48.05,
    transform: "translate(-148.78 318.21) rotate(-77.31)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.6,
    y: 239.83,
    width: 0.75,
    height: 48.04,
    transform: "translate(-163.01 323.89) rotate(-77.31)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.37,
    y: 243.01,
    width: 50.5,
    height: 0.75,
    transform: "translate(-134.67 318.54) rotate(-77.36)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.02,
    y: 237.3,
    width: 50.5,
    height: 0.75,
    transform: "translate(-148.9 289.34) rotate(-77.36)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.28,
    y: 245.91,
    width: 50.5,
    height: 0.75,
    transform: "translate(-127.42 333.41) rotate(-77.36)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,208.43l2.64-11.7,2.87.64a6.76,6.76,0,0,1,1.38.47,3,3,0,0,1,1,.72,2.23,2.23,0,0,1,.49,1.08,3.8,3.8,0,0,1-.08,1.51,3.49,3.49,0,0,1-.47,1.17,1.87,1.87,0,0,1-.75.68,2.11,2.11,0,0,1-1,.18,2.48,2.48,0,0,1,1,.74,2.29,2.29,0,0,1,.46,1.12,4.28,4.28,0,0,1-.09,1.48,4.9,4.9,0,0,1-.55,1.43,2.6,2.6,0,0,1-2,1.34,4.28,4.28,0,0,1-1.48-.11Zm3.7-6.44.72.16a2.12,2.12,0,0,0,1,0,1.08,1.08,0,0,0,.62-.47,2.91,2.91,0,0,0,.35-.95,1.82,1.82,0,0,0,0-1,1.1,1.1,0,0,0-.52-.61,4.3,4.3,0,0,0-1-.36l-.42-.09Zm-1.22,5.42.81.18a1.61,1.61,0,0,0,1.42-.18,2.51,2.51,0,0,0,.67-1.37,3.38,3.38,0,0,0,.09-1.18,1.28,1.28,0,0,0-.4-.79,2.08,2.08,0,0,0-1-.44l-.74-.17Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.1,210.25l2.64-11.7,2.11.48-2.64,11.7Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,211.13l2.63-11.7,2.14.48-2.3,10.23,2.83.64-.34,1.47Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,212.49l2.63-11.7,2.14.48-2.3,10.23,2.83.63-.33,1.48Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,214.67a3.58,3.58,0,0,1-1.67-.81,2.62,2.62,0,0,1-.79-1.45,5.22,5.22,0,0,1,0-2l1.92,0a5.63,5.63,0,0,0-.11,1.24,1.81,1.81,0,0,0,.24.9,1,1,0,0,0,.68.44.87.87,0,0,0,.81-.14,1.35,1.35,0,0,0,.39-.74,2.19,2.19,0,0,0-.06-1.33,5.25,5.25,0,0,0-.71-1.19L144.52,208a4.76,4.76,0,0,1-.72-1.42,3.4,3.4,0,0,1,0-1.71,2.85,2.85,0,0,1,1.29-2,3.2,3.2,0,0,1,2.38-.26,3.39,3.39,0,0,1,1.31.57,2.26,2.26,0,0,1,.72.89,3.27,3.27,0,0,1,.25,1.13,5.92,5.92,0,0,1-.06,1.25l-1.9-.09a5.47,5.47,0,0,0,.1-1,1.35,1.35,0,0,0-.18-.75.94.94,0,0,0-.64-.41.91.91,0,0,0-.8.15,1.2,1.2,0,0,0-.43.72,1.78,1.78,0,0,0,0,1,3.65,3.65,0,0,0,.53.94l1.17,1.62a6.18,6.18,0,0,1,.91,1.7,3.72,3.72,0,0,1,.07,2.08,3,3,0,0,1-.7,1.41,2.74,2.74,0,0,1-1.26.79A3.27,3.27,0,0,1,145,214.67Z",
    style: {
      fill: "#DAC7FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Car--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.05,245.05v17.31H326.36V245.05H313.64v25.3a3.55,3.55,0,0,0,3.55,3.56h5.62a3.55,3.55,0,0,0,3.55-3.56v-1.16h6.17l2.88-1.84h49.33l3.67,2.1h5.64v.9a3.56,3.56,0,0,0,3.56,3.56h5.61a3.56,3.56,0,0,0,3.56-3.56v-25.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.22,274.28h-5.61a3.93,3.93,0,0,1-3.93-3.93v-.53h-5.27a.34.34,0,0,1-.19-.05l-3.58-2H335.52l-2.79,1.78a.36.36,0,0,1-.2.06h-5.79v.79a3.94,3.94,0,0,1-3.93,3.93h-5.62a3.93,3.93,0,0,1-3.93-3.93v-25.3a.38.38,0,0,1,.38-.38h12.72a.38.38,0,0,1,.38.38V262h66.94V245.05a.38.38,0,0,1,.37-.38h12.73a.38.38,0,0,1,.37.38v25.3A3.93,3.93,0,0,1,403.22,274.28Zm-14.71-5.21h5.54a.38.38,0,0,1,.38.38v.9a3.18,3.18,0,0,0,3.18,3.18h5.61a3.18,3.18,0,0,0,3.18-3.18V245.42h-12v16.94a.38.38,0,0,1-.38.38H326.36a.37.37,0,0,1-.37-.38V245.42H314v24.93a3.18,3.18,0,0,0,3.18,3.18h5.62a3.18,3.18,0,0,0,3.18-3.18v-1.16a.37.37,0,0,1,.37-.38h6.06l2.79-1.78a.47.47,0,0,1,.2-.06h49.33a.37.37,0,0,1,.18,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.15,232.59a51.4,51.4,0,0,0-4.6-5.26,1.1,1.1,0,0,1-.2-.28c-.84-1.6-8-13.36-9.23-15.69-2.3-4.29-4.14-3.64-6.6-4h-.21l-18.63-.94q-4.6-.22-9.21,0l-15.12.76c-4.21.21-8.27-.06-10.58,4.13-1.28,2.31-8.39,14.08-9.23,15.69a1.42,1.42,0,0,1-.2.28,51.49,51.49,0,0,0-4.61,5.26c-.52,1-2.62,5-2.62,5.77a119.79,119.79,0,0,0,2.64,20.7,7.51,7.51,0,0,0,5.23,5.45,1.82,1.82,0,0,0,.4.08h16.34a1.23,1.23,0,0,0,1.07-.61l3.86-6.68a1.22,1.22,0,0,1,.3-.34,9.28,9.28,0,0,1,5.71-1.94h22.57a9.28,9.28,0,0,1,5.71,1.94,1.22,1.22,0,0,1,.3.34L381.1,264a1.23,1.23,0,0,0,1.07.61h16.34a1.93,1.93,0,0,0,.4-.08,7.48,7.48,0,0,0,5.22-5.45,119.17,119.17,0,0,0,2.65-20.7C406.78,237.57,404.68,233.63,404.15,232.59ZM324,224.19a108.9,108.9,0,0,1,9.44-14.28,263.54,263.54,0,0,1,53.13-.13l8.93,14.41C375.16,222.22,324,224.19,324,224.19Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.51,265H382.17a1.61,1.61,0,0,1-1.39-.8l-3.87-6.68a.91.91,0,0,0-.2-.24,8.91,8.91,0,0,0-5.48-1.86H348.66a8.91,8.91,0,0,0-5.48,1.86.91.91,0,0,0-.2.24l-3.87,6.68a1.63,1.63,0,0,1-1.39.8H321.38a1.71,1.71,0,0,1-.5-.1,7.88,7.88,0,0,1-5.49-5.73,118.92,118.92,0,0,1-2.65-20.78c0-.63.88-2.47,2.3-5.24l.36-.7a48.49,48.49,0,0,1,4.66-5.35.9.9,0,0,0,.15-.19c.44-.85,2.62-4.52,4.73-8.07,1.92-3.21,3.89-6.53,4.5-7.64,2.19-4,5.83-4.11,9.69-4.27l1.2-.05,10.1-.5,5-.26a92.06,92.06,0,0,1,9.25,0l18.63.94a1,1,0,0,1,.24,0c.38.05.74.08,1.1.1,1.92.13,3.74.26,5.78,4.05.65,1.22,2.89,5,5.06,8.61,1.94,3.25,3.77,6.32,4.17,7.09a1.33,1.33,0,0,0,.14.19,49.17,49.17,0,0,1,4.67,5.35l.35.68c1.43,2.78,2.31,4.63,2.31,5.26a118.92,118.92,0,0,1-2.65,20.78,7.88,7.88,0,0,1-5.49,5.73A1.93,1.93,0,0,1,398.51,265Zm-38.46-58.24c-1.53,0-3.05,0-4.56.11l-5,.25-10.09.51-1.21.05c-3.8.16-7.07.29-9.06,3.89-.61,1.11-2.6,4.44-4.51,7.66-2.11,3.53-4.28,7.19-4.72,8a1.64,1.64,0,0,1-.26.37,47.57,47.57,0,0,0-4.54,5.16l-.36.71a31.82,31.82,0,0,0-2.22,4.9A119.55,119.55,0,0,0,316.12,259a7.13,7.13,0,0,0,5,5.18l.3.07h16.34a.87.87,0,0,0,.74-.43l3.87-6.68a1.61,1.61,0,0,1,.38-.44,9.69,9.69,0,0,1,6-2h22.57a9.69,9.69,0,0,1,5.95,2,1.61,1.61,0,0,1,.38.44l3.87,6.68a.87.87,0,0,0,.74.43h16.34l.3-.07a7.13,7.13,0,0,0,5-5.18,119.55,119.55,0,0,0,2.63-20.61,31.63,31.63,0,0,0-2.23-4.91l-.35-.7h0a47.77,47.77,0,0,0-4.54-5.16,1.83,1.83,0,0,1-.26-.36c-.4-.76-2.22-3.82-4.15-7-2.18-3.65-4.42-7.41-5.08-8.65-1.84-3.42-3.31-3.52-5.17-3.65-.37,0-.75,0-1.14-.1h-.19l-18.63-.94C363.13,206.77,361.59,206.73,360.05,206.73ZM324,224.56a.37.37,0,0,1-.32-.17.35.35,0,0,1,0-.37c3.25-6.39,9.42-14.26,9.48-14.34a.38.38,0,0,1,.26-.14,265.55,265.55,0,0,1,53.21-.13.38.38,0,0,1,.27.17L395.81,224a.36.36,0,0,1,0,.4.35.35,0,0,1-.35.17c-20.08-1.94-70.94,0-71.45,0Zm9.64-14.29a110.93,110.93,0,0,0-9,13.52c5.92-.21,50.82-1.76,70.15,0l-8.43-13.62A267.06,267.06,0,0,0,333.64,210.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.43,264.59l-.92,2.1h44.6l-.65-2.1-4.33-7.47s-1.71-2-5.9-2.1-22.57,0-22.57,0a8.74,8.74,0,0,0-5.9,2.1Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.11,267.07h-44.6a.38.38,0,0,1-.31-.17.38.38,0,0,1,0-.36l.92-2.1,0,0,4.32-7.48.08-.1a9.11,9.11,0,0,1,6.18-2.19c.15,0,18.39-.13,22.55,0s6.1,2.15,6.17,2.23l4.37,7.54.69,2.17a.37.37,0,0,1-.05.34A.4.4,0,0,1,382.11,267.07Zm-44-.75H381.6l-.5-1.61-4.29-7.4h0s-1.68-1.79-5.6-1.92c-4.14-.13-22.36,0-22.54,0a8.5,8.5,0,0,0-5.62,2l-4.29,7.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.23,239.67s3.55,6.3,4.6,7.35,2.23,1,3.67,1.18,21.25,0,21.25,0a3.91,3.91,0,0,0,2.36-1.45c.79-1.18,3.41-7.08,3.41-7.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.65,248.63c-3.16,0-5.69,0-6.19-.06l-.39,0a5,5,0,0,1-3.51-1.26c-1.07-1.07-4.51-7.17-4.65-7.43a.35.35,0,0,1,0-.37.39.39,0,0,1,.32-.19h35.29a.38.38,0,0,1,.32.18.36.36,0,0,1,0,.35c-.11.24-2.65,6-3.45,7.14a4.3,4.3,0,0,1-2.61,1.61C371.24,248.57,362.77,248.63,356.65,248.63ZM342.88,240a58,58,0,0,0,4.21,6.71,4.27,4.27,0,0,0,3,1l.4,0c1.41.13,21,0,21.22,0a3.59,3.59,0,0,0,2.05-1.27c.62-.94,2.48-5,3.14-6.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.75,240.52a57.44,57.44,0,0,0,3.68,5.89c.84.84,1.78.84,2.94.94s17,0,17,0a3.13,3.13,0,0,0,1.89-1.15c.63-.95,2.73-5.68,2.73-5.68Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.29,247.77c-2.53,0-4.56,0-5,0l-.31,0a4.08,4.08,0,0,1-2.86-1,56.42,56.42,0,0,1-3.74-6,.42.42,0,0,1,0-.38.4.4,0,0,1,.33-.18H374a.36.36,0,0,1,.31.17.38.38,0,0,1,0,.36c-.09.19-2.12,4.76-2.76,5.73a3.49,3.49,0,0,1-2.14,1.31C369,247.73,362.19,247.77,357.29,247.77Zm-10.9-6.87a47.33,47.33,0,0,0,3.3,5.24,3.31,3.31,0,0,0,2.39.81l.32,0c1.12.1,16.75,0,17,0a2.82,2.82,0,0,0,1.59-1c.48-.72,1.9-3.84,2.46-5.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.68,262.36l-.79-2.16a3.4,3.4,0,0,0-3.27-2.25l-21.3.22a3.39,3.39,0,0,0-3.21,2.49l-.53,1.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.68,262.74h-29.1a.4.4,0,0,1-.31-.15.37.37,0,0,1,0-.34l.53-1.7a3.79,3.79,0,0,1,3.56-2.76l21.31-.21a3.82,3.82,0,0,1,3.63,2.49l.78,2.17a.38.38,0,0,1,0,.34A.35.35,0,0,1,374.68,262.74Zm-28.6-.75h28.06l-.6-1.66a3,3,0,0,0-2.85-2h-.06l-21.31.21a3,3,0,0,0-2.85,2.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.25 263.41 344.6 265.51 375.82 265.51 375.06 263.41 345.25 263.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.82,265.89H344.6a.4.4,0,0,1-.31-.15.37.37,0,0,1-.05-.34l.65-2.1a.38.38,0,0,1,.36-.26h29.81a.37.37,0,0,1,.35.25l.76,2.09a.39.39,0,0,1-.05.35A.37.37,0,0,1,375.82,265.89Zm-30.72-.75h30.18l-.48-1.35H345.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.43,227.21s.66-5.12,1.84-5.12,6.43,1.44,6.56,2.49-1.05,2.23-2.1,2.5-3.28.52-3.28.52l-.53,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.92,229.94a.35.35,0,0,1-.25-.1l-2.5-2.36a.37.37,0,0,1-.11-.32c.21-1.64.84-5.44,2.21-5.44.93,0,6.75,1.35,6.93,2.82.16,1.26-1.15,2.59-2.38,2.9-.86.21-2.45.42-3.07.5l-.46,1.72a.41.41,0,0,1-.26.27Zm-2.09-2.87,1.89,1.79.37-1.36a.36.36,0,0,1,.31-.27s2.22-.26,3.24-.52,1.92-1.25,1.82-2.08c-.17-.66-4.75-2.16-6.19-2.16C400.88,222.47,400.18,224.46,399.83,227.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.46,227.21s-.66-5.12-1.84-5.12-6.43,1.44-6.56,2.49,1.05,2.23,2.1,2.5,3.28.52,3.28.52l.52,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,229.94h-.1a.41.41,0,0,1-.26-.27l-.46-1.72c-.62-.08-2.21-.29-3.07-.5-1.23-.31-2.54-1.64-2.38-2.9.18-1.47,6-2.82,6.93-2.82,1.36,0,2,3.8,2.21,5.44a.38.38,0,0,1-.12.32l-2.49,2.36A.35.35,0,0,1,318,229.94Zm.66-7.47c-1.44,0-6,1.5-6.19,2.16-.1.83.93,1.86,1.82,2.08s3.21.52,3.23.52a.36.36,0,0,1,.32.27l.36,1.36,1.9-1.79C319.71,224.46,319,222.47,318.62,222.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.67,239a14.43,14.43,0,0,1,3.15,7.09s-11.15-.53-15.48-2.23-4.85-1.84-5-2.63.26-6.42,2-7.34a4.61,4.61,0,0,1,5.24.65c1.71,1.31,3.81,3.28,5,3.68A41.61,41.61,0,0,0,335.67,239Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.82,246.47h0c-.46,0-11.27-.55-15.6-2.25l-1.11-.44c-3.51-1.37-4-1.55-4.11-2.47s.19-6.68,2.16-7.74a5,5,0,0,1,5.65.69c.5.38,1,.81,1.55,1.25a15.53,15.53,0,0,0,3.33,2.36,39.6,39.6,0,0,0,5,.77.39.39,0,0,1,.24.12,14.59,14.59,0,0,1,3.24,7.27.37.37,0,0,1-.09.32A.36.36,0,0,1,338.82,246.47Zm-16.41-12.74a3.92,3.92,0,0,0-1.91.5c-1.44.77-1.91,6.15-1.77,7,.08.49.49.67,3.65,1.9l1.1.44c3.72,1.46,12.72,2,14.89,2.18a14.41,14.41,0,0,0-2.88-6.33,39,39,0,0,1-5.05-.79,15,15,0,0,1-3.56-2.49c-.53-.43-1.05-.86-1.54-1.24A4.79,4.79,0,0,0,322.41,233.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.96,
    cy: 239.39,
    r: 3.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,242.84a3.45,3.45,0,1,1,3.45-3.45A3.45,3.45,0,0,1,325,242.84Zm0-6.15a2.7,2.7,0,1,0,2.7,2.7A2.71,2.71,0,0,0,325,236.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.52,243.24a1.43,1.43,0,1,1-1.42-1.43A1.43,1.43,0,0,1,333.52,243.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.1,245a1.8,1.8,0,1,1,1.8-1.8A1.81,1.81,0,0,1,332.1,245Zm0-2.85a1.05,1.05,0,1,0,1,1.05A1.06,1.06,0,0,0,332.1,242.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.58,239a14.48,14.48,0,0,0-3.14,7.09s11.15-.53,15.48-2.23,4.85-1.84,5-2.63-.26-6.42-2-7.34a4.61,4.61,0,0,0-5.24.65c-1.71,1.31-3.81,3.28-5,3.68A41.71,41.71,0,0,1,384.58,239Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.44,246.47a.36.36,0,0,1-.37-.44,14.59,14.59,0,0,1,3.24-7.27.37.37,0,0,1,.24-.12,39.86,39.86,0,0,0,5-.77,15.52,15.52,0,0,0,3.32-2.36c.53-.44,1.06-.87,1.56-1.25a5,5,0,0,1,5.65-.69c2,1.06,2.3,6.93,2.16,7.74s-.6,1.1-4.11,2.47l-1.11.44c-4.33,1.7-15.14,2.23-15.6,2.25Zm3.33-7.1a14.41,14.41,0,0,0-2.88,6.33c2.17-.13,11.17-.72,14.89-2.18l1.11-.44c3.15-1.24,3.56-1.41,3.64-1.9.13-.8-.34-6.18-1.77-7a4.26,4.26,0,0,0-4.85.62c-.49.38-1,.81-1.53,1.24a15.06,15.06,0,0,1-3.56,2.49A39,39,0,0,1,384.77,239.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.93,239.39a3.08,3.08,0,1,0,3.08-3.07A3.08,3.08,0,0,0,392.93,239.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,242.84a3.45,3.45,0,1,1,3.45-3.45A3.44,3.44,0,0,1,396,242.84Zm0-6.15a2.7,2.7,0,1,0,2.7,2.7A2.71,2.71,0,0,0,396,236.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.44,243.24a1.43,1.43,0,1,0,1.43-1.43A1.43,1.43,0,0,0,387.44,243.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87,245a1.8,1.8,0,1,1,1.8-1.8A1.81,1.81,0,0,1,388.87,245Zm0-2.85a1.05,1.05,0,1,0,1.05,1.05A1,1,0,0,0,388.87,242.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.64,250.69s-12.2,2.36-12.72,2.75a12.4,12.4,0,0,0-1.58,2.63l2.5-.66s5.77.26,7.74-.65S398.64,250.69,398.64,250.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.34,256.44a.39.39,0,0,1-.28-.13.35.35,0,0,1-.05-.4,11.21,11.21,0,0,1,1.68-2.77c.54-.4,9.19-2.1,12.88-2.82a.38.38,0,0,1,.39.16.4.4,0,0,1,0,.42c-.09.13-2.18,3.24-4.22,4.2s-7.22.71-7.86.69l-2.44.64Zm13.44-5.2c-4.58.89-11.13,2.24-11.66,2.52a8,8,0,0,0-1.07,1.74l1.69-.45h.11c.06,0,5.71.24,7.57-.62A11.26,11.26,0,0,0,397.78,251.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.16,250.69s12.2,2.36,12.73,2.75a12.71,12.71,0,0,1,1.57,2.63l-2.49-.66s-5.77.26-7.74-.65S322.16,250.69,322.16,250.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.46,256.44h-.09l-2.44-.64c-.65,0-5.92.21-7.86-.69s-4.13-4.07-4.22-4.2a.4.4,0,0,1,0-.42.36.36,0,0,1,.38-.16c3.7.72,12.35,2.42,12.88,2.82a11.27,11.27,0,0,1,1.69,2.77.39.39,0,0,1-.05.4A.39.39,0,0,1,336.46,256.44ZM334,255h.09l1.7.45a7.78,7.78,0,0,0-1.1-1.76c-.51-.27-7.05-1.61-11.64-2.5a11.42,11.42,0,0,0,3.37,3.18c1.86.86,7.5.62,7.56.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.35,241.41l-.11,0-3.2-1.07h-2.52a.38.38,0,0,1,0-.75h2.58l.11,0,3.26,1.09a.37.37,0,0,1,.24.47A.38.38,0,0,1,383.35,241.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.12,241.25a.36.36,0,0,1-.32-.19.37.37,0,0,1,.13-.51l2.18-1.24a.49.49,0,0,1,.19-.05l2.94,0a.39.39,0,0,1,.37.38c0,.21-.19.42-.38.37l-2.84,0-2.08,1.19A.34.34,0,0,1,337.12,241.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.59,226.74a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51c.34-.2.68-.38,1-.55a.38.38,0,0,1,.5.18.38.38,0,0,1-.17.5c-.34.16-.66.33-1,.52A.45.45,0,0,1,392.59,226.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.15,245.36a.41.41,0,0,1-.16,0,.39.39,0,0,1-.19-.5c2.21-4.85,6.89-13.65,13.44-18.07a.37.37,0,1,1,.42.62c-6.4,4.32-11,13-13.17,17.76A.38.38,0,0,1,378.15,245.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,248.08a.31.31,0,0,1-.13,0,.37.37,0,0,1-.22-.48s.16-.43.48-1.18a.37.37,0,0,1,.49-.2.37.37,0,0,1,.2.49c-.3.73-.47,1.15-.47,1.16A.37.37,0,0,1,377,248.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.42,227.44a.35.35,0,0,1-.2-.05c-.54-.33-1.1-.64-1.66-.91a.38.38,0,0,1,.33-.68c.58.29,1.16.61,1.72.95a.37.37,0,0,1,.13.51A.37.37,0,0,1,328.42,227.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.56,245.46a.38.38,0,0,1-.36-.26c-1.44-4.31-4.9-12.27-11.84-17.07a.39.39,0,0,1-.1-.53.38.38,0,0,1,.53-.09c7.11,4.92,10.65,13.05,12.12,17.45a.38.38,0,0,1-.23.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.24,247.77a.37.37,0,0,1-.36-.29s-.1-.42-.31-1.12a.38.38,0,0,1,.25-.47.38.38,0,0,1,.47.26c.22.73.32,1.16.32,1.16a.38.38,0,0,1-.28.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,233.43a19.58,19.58,0,0,1-1.39-5.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,233.81a.36.36,0,0,1-.34-.24,19.4,19.4,0,0,1-1.43-5.57.38.38,0,0,1,.75,0,19.51,19.51,0,0,0,1.37,5.29.37.37,0,0,1-.21.49A.32.32,0,0,1,323,233.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.63,233.28a27.86,27.86,0,0,0,.77-4.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.63,233.65a.2.2,0,0,1-.11,0,.36.36,0,0,1-.25-.46,27.9,27.9,0,0,0,.76-4.28.37.37,0,0,1,.41-.33.38.38,0,0,1,.34.41,28.12,28.12,0,0,1-.79,4.41A.37.37,0,0,1,397.63,233.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.28,261.11A.35.35,0,0,1,384,261c-.31-.37-3-3.7-3.19-5.32s2.1-4.23,2.92-4.43c.62-.16,11-2.24,11.5-2.33a.37.37,0,1,1,.14.73c-.11,0-10.86,2.17-11.46,2.33-.44.11-2.49,2.24-2.36,3.63.12,1.12,2,3.7,2.91,4.77l16.7-.75.9-11.77a.37.37,0,0,1,.4-.35.38.38,0,0,1,.35.41l-.93,12.1a.37.37,0,0,1-.36.34l-17.22.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.34,261.11h0l-17.22-.78a.37.37,0,0,1-.36-.34l-.93-12.1a.39.39,0,0,1,.35-.41.38.38,0,0,1,.4.35l.9,11.77,16.71.75c.87-1.07,2.78-3.65,2.9-4.77.14-1.39-1.92-3.52-2.36-3.63-.6-.16-11.35-2.31-11.46-2.33a.38.38,0,0,1-.3-.44.39.39,0,0,1,.45-.29c.44.09,10.87,2.17,11.49,2.33.82.2,3.1,2.7,2.92,4.43s-2.87,5-3.18,5.32A.38.38,0,0,1,336.34,261.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.45,244l-.85,0-12.66-1a.38.38,0,0,1-.34-.41.39.39,0,0,1,.41-.34l12.65,1a10.15,10.15,0,0,0,1.56,0l11.67-.9a.37.37,0,0,1,.4.34.38.38,0,0,1-.34.41l-11.67.9C361,244,360.73,244,360.45,244Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.45,245.27l-.85,0-11.82-1a.38.38,0,0,1,.06-.75l11.82,1a10.15,10.15,0,0,0,1.56,0l11.26-.87a.38.38,0,0,1,.4.34.37.37,0,0,1-.34.41l-11.26.87C361,245.26,360.73,245.27,360.45,245.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.45,246.53l-.85,0-11-.88a.38.38,0,0,1-.35-.41.37.37,0,0,1,.41-.34l11,.88a10.15,10.15,0,0,0,1.56,0l10.69-.83a.38.38,0,0,1,.06.75l-10.69.83C361,246.52,360.73,246.53,360.45,246.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.5,224.56h0c-20.08-1.94-70.94,0-71.45,0a.36.36,0,0,1-.33-.17.35.35,0,0,1,0-.37c3.25-6.39,9.42-14.26,9.48-14.34a.38.38,0,0,1,.26-.14,265.55,265.55,0,0,1,53.21-.13.38.38,0,0,1,.27.17L395.81,224a.36.36,0,0,1,0,.4A.36.36,0,0,1,395.5,224.56Zm-61.86-14.29a110.93,110.93,0,0,0-9,13.52c5.92-.21,50.82-1.76,70.15,0l-8.43-13.62A267.06,267.06,0,0,0,333.64,210.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--House--inject-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.04,
    y: 69.97,
    width: 104.58,
    height: 33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.62,103.35H309a.37.37,0,0,1-.37-.38V70a.36.36,0,0,1,.37-.37H413.62A.37.37,0,0,1,414,70v33A.38.38,0,0,1,413.62,103.35Zm-104.2-.75H413.25V70.35H309.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.47 39.86 309.32 69.97 413.62 69.97 361.47 39.86",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.62,70.35H309.32a.38.38,0,0,1-.36-.28.35.35,0,0,1,.17-.42l52.15-30.11a.37.37,0,0,1,.38,0l52.15,30.11a.35.35,0,0,1,.17.42A.38.38,0,0,1,413.62,70.35Zm-102.9-.75h101.5L361.47,40.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.64,
    y: 67.29,
    width: 25.88,
    height: 35.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.52,103.35H356.64a.37.37,0,0,1-.37-.38V67.29a.37.37,0,0,1,.37-.38h25.88a.38.38,0,0,1,.38.38V103A.38.38,0,0,1,382.52,103.35ZM357,102.6h25.13V67.66H357Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.64,
    y: 67.29,
    width: 25.88,
    height: 1.52,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.52,69.18H356.64a.37.37,0,0,1-.37-.37V67.29a.37.37,0,0,1,.37-.38h25.88a.38.38,0,0,1,.38.38v1.52A.38.38,0,0,1,382.52,69.18ZM357,68.43h25.13v-.77H357Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,103H363.12V80.67a6.47,6.47,0,0,1,6.46-6.47h0A6.47,6.47,0,0,1,376,80.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,103.35H363.12a.38.38,0,0,1-.38-.38V80.67a6.84,6.84,0,0,1,13.68,0V103A.38.38,0,0,1,376,103.35Zm-12.55-.75h12.18V80.67a6.09,6.09,0,0,0-12.18,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.53,
    y: 75.75,
    width: 59.95,
    height: 27.22,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.48,103.35h-60a.37.37,0,0,1-.37-.38V75.75a.36.36,0,0,1,.37-.37h60a.37.37,0,0,1,.37.37V103A.38.38,0,0,1,361.48,103.35Zm-59.57-.75H361.1V76.13H301.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.53,
    y: 75.75,
    width: 59.95,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.48,77.34h-60a.37.37,0,0,1-.37-.38V75.75a.36.36,0,0,1,.37-.37h60a.37.37,0,0,1,.37.37V77A.38.38,0,0,1,361.48,77.34Zm-59.57-.75H361.1v-.46H301.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.13,
    y: 78,
    width: 46.75,
    height: 24.98,
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.88,103.35H308.13a.38.38,0,0,1-.38-.38V78a.38.38,0,0,1,.38-.38h46.75a.38.38,0,0,1,.38.38v25A.38.38,0,0,1,354.88,103.35Zm-46.38-.75h46V78.37h-46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.5 55.84 299.69 74.2 363.32 74.2 331.5 55.84",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.32,74.58H299.69a.36.36,0,0,1-.36-.28.37.37,0,0,1,.17-.42l31.82-18.37a.35.35,0,0,1,.37,0l31.82,18.37a.38.38,0,0,1,.17.42A.36.36,0,0,1,363.32,74.58Zm-62.23-.75h60.83L331.51,56.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.69,
    y: 74.2,
    width: 63.63,
    height: 1.55,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.32,76.13H299.69a.37.37,0,0,1-.37-.38V74.2a.37.37,0,0,1,.37-.37h63.63a.37.37,0,0,1,.37.37v1.55A.37.37,0,0,1,363.32,76.13Zm-63.25-.75h62.87v-.8H300.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.58 56.93 353.11 66.44 386.06 66.44 369.58 56.93",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,66.82H353.11a.4.4,0,0,1-.37-.28.38.38,0,0,1,.18-.42l16.47-9.51a.37.37,0,0,1,.38,0l16.47,9.51a.37.37,0,0,1-.18.7Zm-31.55-.75h30.15l-15.08-8.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.11,
    y: 66.44,
    width: 32.95,
    height: 1.53,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,68.35H353.11a.38.38,0,0,1-.38-.38V66.44a.38.38,0,0,1,.38-.37h32.95a.38.38,0,0,1,.37.37V68A.38.38,0,0,1,386.06,68.35Zm-32.58-.75h32.2v-.78h-32.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.83,
    y: 80,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.62,84.16h-3.79a.36.36,0,0,1-.37-.37V80a.37.37,0,0,1,.37-.37h3.79A.38.38,0,0,1,314,80v3.79A.37.37,0,0,1,313.62,84.16Zm-3.41-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.51,
    y: 80,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.3,84.16h-3.79a.37.37,0,0,1-.38-.37V80a.38.38,0,0,1,.38-.37h3.79a.38.38,0,0,1,.37.37v3.79A.37.37,0,0,1,319.3,84.16Zm-3.42-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.19,
    y: 80,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,84.16h-3.79a.37.37,0,0,1-.38-.37V80a.38.38,0,0,1,.38-.37H325a.38.38,0,0,1,.37.37v3.79A.37.37,0,0,1,325,84.16Zm-3.42-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.87,
    y: 80,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.66,84.16h-3.79a.37.37,0,0,1-.38-.37V80a.38.38,0,0,1,.38-.37h3.79A.38.38,0,0,1,331,80v3.79A.37.37,0,0,1,330.66,84.16Zm-3.42-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.55,
    y: 80,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.33,84.16h-3.78a.37.37,0,0,1-.38-.37V80a.38.38,0,0,1,.38-.37h3.78a.38.38,0,0,1,.38.37v3.79A.37.37,0,0,1,336.33,84.16Zm-3.41-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.23,
    y: 80,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,84.16h-3.78a.37.37,0,0,1-.38-.37V80a.38.38,0,0,1,.38-.37H342a.38.38,0,0,1,.38.37v3.79A.37.37,0,0,1,342,84.16Zm-3.41-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.91,
    y: 80,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.69,84.16h-3.78a.37.37,0,0,1-.38-.37V80a.38.38,0,0,1,.38-.37h3.78a.38.38,0,0,1,.38.37v3.79A.37.37,0,0,1,347.69,84.16Zm-3.41-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.59,
    y: 80,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.37,84.16h-3.78a.37.37,0,0,1-.38-.37V80a.38.38,0,0,1,.38-.37h3.78a.38.38,0,0,1,.38.37v3.79A.37.37,0,0,1,353.37,84.16ZM350,83.41h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.83,
    y: 85.57,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.62,89.74h-3.79a.37.37,0,0,1-.37-.38V85.57a.37.37,0,0,1,.37-.37h3.79a.38.38,0,0,1,.37.37v3.79A.38.38,0,0,1,313.62,89.74ZM310.21,89h3V86h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.51,
    y: 85.57,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.3,89.74h-3.79a.38.38,0,0,1-.38-.38V85.57a.38.38,0,0,1,.38-.37h3.79a.38.38,0,0,1,.37.37v3.79A.38.38,0,0,1,319.3,89.74ZM315.88,89h3V86h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.19,
    y: 85.57,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,89.74h-3.79a.38.38,0,0,1-.38-.38V85.57a.38.38,0,0,1,.38-.37H325a.38.38,0,0,1,.37.37v3.79A.38.38,0,0,1,325,89.74ZM321.56,89h3V86h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.87,
    y: 85.57,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.66,89.74h-3.79a.38.38,0,0,1-.38-.38V85.57a.38.38,0,0,1,.38-.37h3.79a.38.38,0,0,1,.37.37v3.79A.38.38,0,0,1,330.66,89.74ZM327.24,89h3V86h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.55,
    y: 85.57,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.33,89.74h-3.78a.38.38,0,0,1-.38-.38V85.57a.38.38,0,0,1,.38-.37h3.78a.38.38,0,0,1,.38.37v3.79A.38.38,0,0,1,336.33,89.74ZM332.92,89h3V86h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.23,
    y: 85.57,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,89.74h-3.78a.38.38,0,0,1-.38-.38V85.57a.38.38,0,0,1,.38-.37H342a.38.38,0,0,1,.38.37v3.79A.38.38,0,0,1,342,89.74ZM338.6,89h3V86h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.91,
    y: 85.57,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.69,89.74h-3.78a.38.38,0,0,1-.38-.38V85.57a.38.38,0,0,1,.38-.37h3.78a.38.38,0,0,1,.38.37v3.79A.38.38,0,0,1,347.69,89.74ZM344.28,89h3V86h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.59,
    y: 85.57,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.37,89.74h-3.78a.38.38,0,0,1-.38-.38V85.57a.38.38,0,0,1,.38-.37h3.78a.38.38,0,0,1,.38.37v3.79A.38.38,0,0,1,353.37,89.74ZM350,89h3V86h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.83,
    y: 91.15,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.62,95.31h-3.79a.37.37,0,0,1-.37-.38V91.15a.37.37,0,0,1,.37-.38h3.79a.38.38,0,0,1,.37.38v3.78A.38.38,0,0,1,313.62,95.31Zm-3.41-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.51,
    y: 91.15,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.3,95.31h-3.79a.38.38,0,0,1-.38-.38V91.15a.38.38,0,0,1,.38-.38h3.79a.38.38,0,0,1,.37.38v3.78A.38.38,0,0,1,319.3,95.31Zm-3.42-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.19,
    y: 91.15,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,95.31h-3.79a.38.38,0,0,1-.38-.38V91.15a.38.38,0,0,1,.38-.38H325a.38.38,0,0,1,.37.38v3.78A.38.38,0,0,1,325,95.31Zm-3.42-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.87,
    y: 91.15,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.66,95.31h-3.79a.38.38,0,0,1-.38-.38V91.15a.38.38,0,0,1,.38-.38h3.79a.38.38,0,0,1,.37.38v3.78A.38.38,0,0,1,330.66,95.31Zm-3.42-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.55,
    y: 91.15,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.33,95.31h-3.78a.38.38,0,0,1-.38-.38V91.15a.38.38,0,0,1,.38-.38h3.78a.38.38,0,0,1,.38.38v3.78A.38.38,0,0,1,336.33,95.31Zm-3.41-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.23,
    y: 91.15,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,95.31h-3.78a.38.38,0,0,1-.38-.38V91.15a.38.38,0,0,1,.38-.38H342a.38.38,0,0,1,.38.38v3.78A.38.38,0,0,1,342,95.31Zm-3.41-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.91,
    y: 91.15,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.69,95.31h-3.78a.38.38,0,0,1-.38-.38V91.15a.38.38,0,0,1,.38-.38h3.78a.38.38,0,0,1,.38.38v3.78A.38.38,0,0,1,347.69,95.31Zm-3.41-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.59,
    y: 91.15,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.37,95.31h-3.78a.38.38,0,0,1-.38-.38V91.15a.38.38,0,0,1,.38-.38h3.78a.38.38,0,0,1,.38.38v3.78A.38.38,0,0,1,353.37,95.31ZM350,94.56h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.83,
    y: 96.72,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.62,100.88h-3.79a.37.37,0,0,1-.37-.38V96.72a.37.37,0,0,1,.37-.38h3.79a.38.38,0,0,1,.37.38v3.78A.38.38,0,0,1,313.62,100.88Zm-3.41-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.51,
    y: 96.72,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.3,100.88h-3.79a.38.38,0,0,1-.38-.38V96.72a.38.38,0,0,1,.38-.38h3.79a.38.38,0,0,1,.37.38v3.78A.38.38,0,0,1,319.3,100.88Zm-3.42-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.19,
    y: 96.72,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,100.88h-3.79a.38.38,0,0,1-.38-.38V96.72a.38.38,0,0,1,.38-.38H325a.38.38,0,0,1,.37.38v3.78A.38.38,0,0,1,325,100.88Zm-3.42-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.87,
    y: 96.72,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.66,100.88h-3.79a.38.38,0,0,1-.38-.38V96.72a.38.38,0,0,1,.38-.38h3.79a.38.38,0,0,1,.37.38v3.78A.38.38,0,0,1,330.66,100.88Zm-3.42-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.55,
    y: 96.72,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.33,100.88h-3.78a.38.38,0,0,1-.38-.38V96.72a.38.38,0,0,1,.38-.38h3.78a.38.38,0,0,1,.38.38v3.78A.38.38,0,0,1,336.33,100.88Zm-3.41-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.23,
    y: 96.72,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,100.88h-3.78a.38.38,0,0,1-.38-.38V96.72a.38.38,0,0,1,.38-.38H342a.38.38,0,0,1,.38.38v3.78A.38.38,0,0,1,342,100.88Zm-3.41-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.91,
    y: 96.72,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.69,100.88h-3.78a.38.38,0,0,1-.38-.38V96.72a.38.38,0,0,1,.38-.38h3.78a.38.38,0,0,1,.38.38v3.78A.38.38,0,0,1,347.69,100.88Zm-3.41-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.59,
    y: 96.72,
    width: 3.79,
    height: 3.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.37,100.88h-3.78a.38.38,0,0,1-.38-.38V96.72a.38.38,0,0,1,.38-.38h3.78a.38.38,0,0,1,.38.38v3.78A.38.38,0,0,1,353.37,100.88Zm-3.41-.75h3v-3h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.59 102.97 378.35 102.97 378.35 67.29 397.47 56.93 416.59 67.29 416.59 102.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.59,103.35H378.35A.37.37,0,0,1,378,103V67.29a.36.36,0,0,1,.19-.33L397.29,56.6a.38.38,0,0,1,.36,0L416.77,67a.36.36,0,0,1,.19.33V103A.38.38,0,0,1,416.59,103.35Zm-37.86-.75h37.48V67.51L397.47,57.36,378.73,67.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.51 68.81 397.47 56.87 375.43 68.81 374.74 67.54 397.47 55.23 420.19 67.54 419.51 68.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.51,69.18a.39.39,0,0,1-.18,0L397.47,57.29,375.61,69.14a.49.49,0,0,1-.29,0,.41.41,0,0,1-.22-.19l-.69-1.26a.38.38,0,0,1,.15-.51L397.29,54.9a.38.38,0,0,1,.36,0l22.72,12.31a.38.38,0,0,1,.16.51L419.84,69a.41.41,0,0,1-.22.19Zm-22-12.69a.41.41,0,0,1,.18,0L419.36,68.3l.33-.61-22.22-12-22.22,12,.33.61,21.71-11.76A.41.41,0,0,1,397.47,56.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.35 67.29 378.35 68.16 397.47 57.8 416.59 68.16 416.59 67.29 397.47 56.93 378.35 67.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.59,68.53a.37.37,0,0,1-.18,0L397.47,58.22,378.53,68.49a.38.38,0,0,1-.37,0,.38.38,0,0,1-.18-.32v-.87a.36.36,0,0,1,.19-.33L397.29,56.6a.38.38,0,0,1,.36,0L416.77,67a.36.36,0,0,1,.19.33v.87a.38.38,0,0,1-.18.32A.45.45,0,0,1,416.59,68.53ZM397.47,57.42a.41.41,0,0,1,.18,0l18.56,10.06v0L397.47,57.36,378.73,67.53l18.56-10.06A.41.41,0,0,1,397.47,57.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.09,
    y: 79.52,
    width: 6.42,
    height: 4.46,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.5,84.35h-6.41a.37.37,0,0,1-.38-.37V79.52a.38.38,0,0,1,.38-.38h6.41a.38.38,0,0,1,.38.38V84A.37.37,0,0,1,404.5,84.35Zm-6-.75h5.67V79.89h-5.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.09,
    y: 85.44,
    width: 6.42,
    height: 4.46,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.5,90.28h-6.41a.38.38,0,0,1-.38-.38V85.44a.38.38,0,0,1,.38-.37h6.41a.38.38,0,0,1,.38.37V89.9A.38.38,0,0,1,404.5,90.28Zm-6-.75h5.67V85.82h-5.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.09,
    y: 73.29,
    width: 6.42,
    height: 4.76,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.5,78.43h-6.41a.38.38,0,0,1-.38-.38V73.29a.37.37,0,0,1,.38-.37h6.41a.37.37,0,0,1,.38.37v4.76A.38.38,0,0,1,404.5,78.43Zm-6-.75h5.67v-4h-5.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.2,
    y: 73.29,
    width: 6.42,
    height: 4.76,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.62,78.43H390.2a.38.38,0,0,1-.37-.38V73.29a.37.37,0,0,1,.37-.37h6.42a.36.36,0,0,1,.37.37v4.76A.37.37,0,0,1,396.62,78.43Zm-6-.75h5.66v-4h-5.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.2,
    y: 85.44,
    width: 6.42,
    height: 4.46,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.62,90.28H390.2a.38.38,0,0,1-.37-.38V85.44a.38.38,0,0,1,.37-.37h6.42a.37.37,0,0,1,.37.37V89.9A.37.37,0,0,1,396.62,90.28Zm-6-.75h5.66V85.82h-5.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.2,
    y: 79.52,
    width: 6.42,
    height: 4.46,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.62,84.35H390.2a.37.37,0,0,1-.37-.37V79.52a.38.38,0,0,1,.37-.38h6.42a.37.37,0,0,1,.37.38V84A.36.36,0,0,1,396.62,84.35Zm-6-.75h5.66V79.89h-5.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.09,
    y: 91.37,
    width: 6.42,
    height: 4.1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.5,95.85h-6.41a.38.38,0,0,1-.38-.38v-4.1a.38.38,0,0,1,.38-.38h6.41a.38.38,0,0,1,.38.38v4.1A.38.38,0,0,1,404.5,95.85Zm-6-.75h5.67V91.74h-5.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.2,
    y: 91.37,
    width: 6.42,
    height: 4.1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.62,95.85H390.2a.38.38,0,0,1-.37-.38v-4.1a.38.38,0,0,1,.37-.38h6.42a.37.37,0,0,1,.37.38v4.1A.37.37,0,0,1,396.62,95.85Zm-6-.75h5.66V91.74h-5.66Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--piggy-bank--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.19,60.92s9.48-5.35,10.86-4.83-1.21,11-1.55,11.72S148.19,60.92,148.19,60.92Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.45,68.23c-1,0-5.69-3.8-9.51-7a.4.4,0,0,1-.13-.33.42.42,0,0,1,.19-.29c2.26-1.27,9.75-5.38,11.18-4.85a.89.89,0,0,1,.48.52c.78,2-1.52,11.11-1.83,11.72a.49.49,0,0,1-.32.24ZM148.84,61c3.55,3,7.41,6,8.41,6.45.69-1.83,2.42-10.34,1.65-11C158.18,56.17,153.31,58.49,148.84,61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.19,66.57h-.09c-.24,0-1-.24-1-2,0-1.47,1.21-3.91,2.22-5.69.53-.93.95-1.58.95-1.58a.35.35,0,0,1,.51-.11.36.36,0,0,1,.12.51s-.41.64-.93,1.55c-1.36,2.41-2.12,4.3-2.12,5.32s.26,1.27.38,1.28.46-.28.6-1l1.21-5a.39.39,0,0,1,.46-.28.37.37,0,0,1,.27.45l-1.2,5C157.32,65.94,156.8,66.57,156.19,66.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.56,82.84c0,3.39-2.11,6.13-4.71,6.13s-4.7-2.74-4.7-6.13,2.1-6.12,4.7-6.12S83.56,79.46,83.56,82.84Z",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.85,89.34c-2.8,0-5.08-2.91-5.08-6.5s2.28-6.5,5.08-6.5,5.08,2.92,5.08,6.5S81.65,89.34,78.85,89.34Zm0-12.25c-2.39,0-4.33,2.58-4.33,5.75s1.94,5.75,4.33,5.75,4.33-2.58,4.33-5.75S81.24,77.09,78.85,77.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.51,
    cy: 88.84,
    rx: 44.85,
    ry: 37.97,
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.51,127.19c-24.93,0-45.22-17.2-45.22-38.35S96.58,50.5,121.51,50.5s45.23,17.2,45.23,38.34S146.45,127.19,121.51,127.19Zm0-75.94C97,51.25,77,68.11,77,88.84s19.95,37.6,44.47,37.6S166,109.57,166,88.84,146,51.25,121.51,51.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.64,115a46.76,46.76,0,0,1-29.13,9.78c-20.12,0-37-11.84-41.36-27.75",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.51,125.18c-20,0-37.17-11.53-41.72-28a.37.37,0,1,1,.72-.2c4.46,16.18,21.32,27.48,41,27.48a46.32,46.32,0,0,0,28.89-9.71.39.39,0,0,1,.53.06.38.38,0,0,1-.06.53A47.1,47.1,0,0,1,121.51,125.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.06,90c0-.4,0-.8,0-1.2a31,31,0,0,1,2.67-12.57",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.06,90.41a.37.37,0,0,1-.37-.36c0-.4,0-.8,0-1.21a31.35,31.35,0,0,1,2.7-12.72.39.39,0,0,1,.5-.19.37.37,0,0,1,.19.49,30.62,30.62,0,0,0-2.64,12.42c0,.4,0,.79,0,1.18a.39.39,0,0,1-.36.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,55.44h-.11a49.55,49.55,0,0,0-26.79,0,.36.36,0,0,1-.46-.25.38.38,0,0,1,.26-.47,50.26,50.26,0,0,1,27.2,0,.38.38,0,0,1,.26.46A.37.37,0,0,1,135,55.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.88,77.12s5.68-1.89,6.55-.86.86,13.1.17,15.35-5.35,1.72-8.62-.69a6.89,6.89,0,0,1-2.93-5.87",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.89,93.41a11.11,11.11,0,0,1-6.13-2.19,7.24,7.24,0,0,1-3.09-6.2.38.38,0,0,1,.41-.34.37.37,0,0,1,.34.41,6.48,6.48,0,0,0,2.78,5.52c2.22,1.64,5.21,2.44,7,1.87a1.52,1.52,0,0,0,1.09-1c.71-2.3.63-14.07-.1-15-.42-.5-3.52.1-6.15,1a.37.37,0,0,1-.47-.24.37.37,0,0,1,.24-.47c1.39-.47,6-1.89,7-.75s.88,13.64.25,15.7a2.28,2.28,0,0,1-1.57,1.47A4.68,4.68,0,0,1,167.89,93.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,85.43a.38.38,0,0,1-.06-.75l3.45-.51a.37.37,0,1,1,.11.74l-3.44.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,88.33s-.87,6,.17,6.21,2.76-2.93,2.76-2.93S160.08,88.85,159.57,88.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.81,94.92h-.13c-1.16-.2-.9-3.72-.49-6.63a.39.39,0,0,1,.26-.31.38.38,0,0,1,.38.09c.52.52,2.85,3.19,2.95,3.3a.38.38,0,0,1,0,.43C162.41,92.54,161,94.92,159.81,94.92Zm0-5.75c-.3,2.52-.31,4.73,0,5,.41,0,1.45-1.24,2.2-2.53C161.62,91.17,160.53,89.94,159.83,89.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.43,74.19c.32,1.25.13,2.37-.42,2.52s-1.26-.76-1.58-2-.13-2.37.42-2.51S156.11,73,156.43,74.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.31,57.49s10.85-10.85,13-8.73,1.32,11.38,1.32,12.7v3.7",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,65.54a.37.37,0,0,1-.37-.38v-3.7c0-.19,0-.55,0-1,.13-2.66.45-9.72-1.25-11.42-1.27-1.28-8,4.34-12.43,8.74a.39.39,0,0,1-.53,0,.37.37,0,0,1,0-.53c1.85-1.86,11.23-11,13.49-8.74,1.72,1.72,1.69,7.31,1.47,12,0,.46,0,.8,0,1v3.7A.38.38,0,0,1,152.6,65.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.51,66.13a2.22,2.22,0,0,1-1.83-.85c-1.21-1.62,2.4-13.7,3.61-15.44.17-.24.62-.88,1.15-.69s.62,1.18.57,2a.38.38,0,0,1-.4.35.39.39,0,0,1-.35-.4,4.21,4.21,0,0,0-.07-1.14,2.06,2.06,0,0,0-.28.34c-1.33,1.9-4.44,13.48-3.63,14.56a1.65,1.65,0,0,0,1.69.5,3,3,0,0,0,2.3-2.27c.67-2.49.17-9.8.16-9.87a.38.38,0,1,1,.75,0c0,.3.52,7.5-.18,10.12a3.77,3.77,0,0,1-2.89,2.81A3.05,3.05,0,0,1,148.51,66.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "92.26 114.01 98.19 130.05 104.74 130.05 107.67 121.77",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.74,130.42H98.19a.38.38,0,0,1-.35-.24l-5.93-16a.37.37,0,0,1,.7-.26l5.84,15.79h6l2.84-8a.38.38,0,0,1,.48-.23.37.37,0,0,1,.23.48l-2.93,8.27A.39.39,0,0,1,104.74,130.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "146.98 116.08 141.29 130.05 134.74 130.05 131.81 121.77",
    style: {
      fill: "#DAC7FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.29,130.42h-6.55a.37.37,0,0,1-.35-.25l-2.93-8.27a.37.37,0,1,1,.7-.25l2.85,8h6l5.59-13.73a.38.38,0,0,1,.7.29l-5.69,14A.38.38,0,0,1,141.29,130.42Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanding);
export default __webpack_public_path__ + "static/media/landing.0b2a130527113b8a09e1e303de91cdfc.svg";
export { ForwardRef as ReactComponent };